import React from 'react'

const VinLocation = () => (
  <svg viewBox="0 0 403.582 513.321">
    <path
      fill="#2B2B2B"
      d="M6.773,151.776c0,0-4.187-17.39,2.769-25.124c0,0,2.17-3.752,6.21-0.458c0,0,2.746,1.373,3.142,6.315
	C18.893,132.51,7.528,130.315,6.773,151.776z"
    />
    <path
      fill-opacity="0.252"
      d="M227.344,177.109L63.585,160.721l-58.002,7.102c0,0,96.942,34.975,221.826,11.325
	C228.581,178.926,228.53,177.237,227.344,177.109z"
    />
    <path
      fill="#2B2B2B"
      d="M104.358,132.006c0,0-6.36-12.722-16.794-1.739c0,0-8.695,14.998-4.027,31.798l1.67,7.122l0.915,0.572
	l2.099-0.601C88.221,169.158,91.361,138.596,104.358,132.006z"
    />
    <g>
      <path
        opacity="0.5"
        fill="#2D2D2D"
        d="M175.882,93.064h5.446l-0.366-1.739l-6.635-1.876
		C175.425,90.135,175.882,93.064,175.882,93.064z"
      />
      <path
        opacity="0.5"
        fill="#2D2D2D"
        d="M158.081,93.293h5.903c0.137-3.798,2.334-5.034,2.334-5.034
		c-3.752-1.144-9.838-0.732-9.838-0.732L158.081,93.293z"
      />
      <path
        opacity="0.5"
        fill="#2D2D2D"
        d="M148.105,93.293l-0.961-4.485c0,0-6.315,1.373-7.688,2.242
		C139.456,91.05,143.117,92.744,148.105,93.293z"
      />
    </g>
    <path
      d="M91.1,138.854c3.158-6.012,12.429-6.063,12.429-6.063c11.234,0,20.342,12.23,20.342,27.316l-1.088,3.614
	c0,0,2.093,10.85-5.489,19.223c0,0-2.237,2.586-7.917,3.05c0,0-9.748,1.618-15.865-1.036s0,0,0,0l14.612-11.362"
    />
    <path
      d="M13.769,169.083c0,0,8.386,4.289,15.509-1.365c0,0,2.092-1.594,3.088-6.949l-8.982-3.795
	C23.384,156.975,21.538,169.94,13.769,169.083z"
    />
    <ellipse cx="16.365" cy="149.392" rx="9.859" ry="20.406" />
    <path
      d="M54.754,110.264c1.636-4.196,5.884-7.2,10.869-7.2c4.984,0,9.232,3.004,10.868,7.2h2.132c-1.704-5.32-6.886-9.2-13-9.2
	s-11.297,3.88-13.001,9.2H54.754z"
    />
    <path
      fill="#EBEBEB"
      d="M7.07,156.305H7.94c0,0-3.569-11.715-1.327-22.057c2.242-10.342,7.047-8.694,7.047-8.694
	s3.935,0.824,6.818,14.14c2.883,13.316,3.112,14.826,3.112,14.826s0.883,4.487,3.252,5.791c0,0,54.887,6.976,59.281,9.447
	l-1.167-2.814c0,0-4.256-14.758,0.48-28.486c0,0,2.196-9.061,10.159-9.335c7.962-0.275,15.238,19.426,15.238,19.426
	s5.148,20.798,9.61,22.308c0,0,11.961,0.151,19.425-1.441l89.508-5.972c0,0,4.164-5.629,5.034-9.152c0,0,0.137-0.572-0.297-0.938
	c0,0,2.746-9.061,2.608-12.836c0,0,0.183-1.167-1.053-3.089c-1.235-1.922-1.727-14.003-1.659-17.641
	c0.06-3.191-0.219-8.665-1.738-10.188c-0.159-0.159-0.299-0.266-0.453-0.349c-0.053-0.028-0.102-0.076-0.143-0.102
	c0,0-3.638-0.927-5.011-2.608c-1.373-1.682-0.824-2.059-3.913-3.192c-3.089-1.133-3.432-0.652-5.045-1.956
	c0,0-27.731-18.396-46.745-21.004c-17.239-2.365-38.096-6.864-85.184-1.785c0,0-33.703,0.961-53.334,34.046
	c0,0-6.315,1.03-8.878,3.478c0,0-5.537,0.412-7.459,2.219c-1.922,1.808-5.457,5.079-5.457,5.079S0.595,129.352,7.07,156.305z
	 M122.754,82.681c0,0,23.395-2.908,52.395,0.873l27.367,11.958c0,0-38.097-0.926-60.599,0.447c0,0-2.313,0.539-4.999-1.946
	C134.231,91.528,122.754,82.681,122.754,82.681z M36.403,110.041c8.146-8.786,17.847-23.733,42.1-26.942
	c22.743-3.009,42.832,11.2,42.832,11.2c-8.237,8.328-21.599,9.701-21.599,9.701c-39.103,7.036-63.333,8.695-63.333,8.695V110.041z"
    />
    <polygon fill="#939393" points="62.866,109.796 43.116,112.105 43.2,111.84 62.866,109.664 " />
    <path
      d="M122.754,82.681c0,0,11.477,8.847,14.163,11.332c2.686,2.485,4.999,1.946,4.999,1.946
	c22.503-1.373,60.599-0.447,60.599-0.447l-27.367-11.958C146.149,79.774,122.754,82.681,122.754,82.681z M174.326,89.449
	l6.635,1.876l0.366,1.739h-5.446C175.882,93.064,175.425,90.135,174.326,89.449z M156.479,87.527c0,0,6.086-0.412,9.838,0.732
	c0,0-2.196,1.235-2.334,5.034h-5.903L156.479,87.527z M139.456,91.05c1.373-0.869,7.688-2.242,7.688-2.242l0.961,4.485
	C143.117,92.744,139.456,91.05,139.456,91.05z"
    />
    <path
      fill="#939393"
      d="M146.256,108.946c0,0,0.183,5.034,5.171,4.805h22.835c0,0-3.707,11.074-9.976,11.989
	c-6.269,0.915-30.98,3.935-38.348-3.981c0,0-1.281-1.327-1.144-5.674c0.137-4.347,0.778-4.942,4.21-5.308L146.256,108.946z"
    />
    <path
      fill="#939393"
      d="M217.434,115.908c3.014,10.205,7.459,9.61,7.459,9.61s6.223,0.046,7.871,0
	c1.647-0.046,1.83-1.922,1.83-1.922s-0.092-4.759,0-8.786s-2.929-5.663-2.929-5.663l0.004,3.029c0,0,0.149,1.63-0.874,1.651
	c-1.167,0.024-14.037-0.034-14.037-0.034L217.434,115.908z"
    />
    <path
      opacity="0.5"
      fill="#2D2D2D"
      d="M36.403,112.695c0,0,24.23-1.659,63.333-8.695c0,0,13.362-1.373,21.599-9.701
	c0,0-20.089-14.209-42.832-11.2c-24.252,3.209-33.954,18.156-42.1,26.942V112.695z"
    />
    <g>
      <path
        d="M36.403,110.041v2.654c0,0,2.3-0.158,6.621-0.581l0.404-4.682c13.11-16.405,29.928-19.7,29.928-19.7
		c-5.97,10.637-10.397,21.832-10.489,22.064c4-0.532,8.409-1.152,13.196-1.875l6.56-18.061h5.903c0,0-3.89,2.38-2.242,12.401
		c0,0-5.874,1.852-7.834,5.296c6.473-0.997,13.591-2.172,21.287-3.557c0,0,13.362-1.373,21.599-9.701c0,0-20.089-14.209-42.832-11.2
		C54.25,86.308,44.549,101.255,36.403,110.041z M107.241,100.111c0,0,2.38-6.727,4.439-9.198l5.72,2.791c0,0,2.974,1.3-1.968,3.739
		C110.49,99.882,107.241,100.111,107.241,100.111z M96.075,89.861c0,0,5.674,0.183,7.093-0.458c0,0,0.229,1.053,2.425,1.098
		l-5.812,12.493v-1.281C99.782,101.713,99.233,91.92,96.075,89.861z"
      />
      <path d="M76.164,107.906l2.049-0.312C77.524,107.7,76.84,107.804,76.164,107.906z" />
      <path d="M43.029,112.114l19.93-2.549C54.355,110.708,47.538,111.673,43.029,112.114z" />
    </g>
    <path
      fill="#DCDCDC"
      d="M81.747,159.497l-52.9-6.223c0,0,4.942-2.105,8.649-1.693c3.707,0.412,36.471,3.112,36.471,3.112
	S77.903,154.921,81.747,159.497z"
    />
    <polygon fill="#C0C0C0" points="77.858,163.73 83.212,165.858 28.848,157.941 28.619,156.66 " />
    <path
      fill="#DCDCDC"
      d="M119.779,115.601c0,0-61.842-0.824-94.547,5.949c0,0,2.973,1.716,9.408,0.847
	C34.641,122.397,79.514,119.72,119.779,115.601z"
    />
    <path
      fill="#BCBCBC"
      d="M81.701,115.739c0,0,1.442,0.189,1.939,0.137c0.444-0.046,2.172-0.011,3.619-0.491
	c0.157-0.087,0.324-0.158,0.505-0.194c0.001,0,0.001,0,0.002-0.001v0.001c0.113-0.022,0.229-0.035,0.348-0.035
	c0.978,0,1.772,0.793,1.772,1.772c0,0.979-0.793,1.772-1.772,1.772c-0.077,0-0.151-0.013-0.225-0.023l0,0.008
	c0,0-0.681,0.006-1.967-0.629c-1.287-0.635-3.003,0.12-3.003,0.12s-1.424,1.03-2.231,0.172
	C79.882,117.489,79.968,115.825,81.701,115.739z"
    />
    <path fill="#FFFFFF" d="M127.787,106.746c0,0-24.436-0.595-45.441,5.949c0,0,15.882-4.4,38.988-3.34" />
    <path fill="#DCDCDC" d="M161.347,153.403c0,0-24.299-1.602-35.693,0.229C125.654,153.632,155.261,155.737,161.347,153.403z" />
    <path
      fill="#939393"
      d="M155.095,153.838h-10.993c-0.279,0-0.529,0.173-0.627,0.434l-0.564,1.501
	c-0.135,0.359,0.13,0.742,0.514,0.742h10.587c0.345,0,0.662-0.195,0.817-0.503l0.723-1.433
	C155.722,154.239,155.475,153.838,155.095,153.838z"
    />
    <path
      fill="#939393"
      d="M234.997,150.204l-2.982,0.172c-0.313,0-0.548,0.288-0.484,0.595l0.38,1.835
	c0.067,0.324,0.352,0.556,0.683,0.556h1.58L234.997,150.204z"
    />
    <path fill="#DCDCDC" d="M235.331,149.747c0,0-5.251,0.429-5.852,0.789c0,0,2.277,0.457,5.726-0.332L235.331,149.747z" />
    <ellipse fill="#939393" cx="199.22" cy="167.709" rx="7.962" ry="5.342" />
    <g>
      <path
        d="M185.812,166.603c0,0,1.171,3.844,3.113,6.74c0.149,0.241,0.316,0.476,0.502,0.706c0.733,0.967,1.12,1.244,2.035,1.981
		c2.865,1.838,7.725,3.209,12.508,3.112c5.594-0.113,10.458-1.865,13.109-4.392c2.898-2.447,4.608-5.629,4.557-8.148h-4.027
		c-2.55-2.81-7.871-4.677-13.985-4.553c-5.711,0.116-10.658,1.94-13.269,4.553h-3.948c0.001,0.029,0.007,0.059,0.009,0.088
		L185.812,166.603z M192.68,166.862c0.269-2.429,3.728-4.099,7.726-3.73c3.998,0.369,7.022,2.637,6.753,5.066
		c-0.269,2.429-3.728,4.099-7.726,3.73C195.435,171.559,192.412,169.291,192.68,166.862z"
      />
    </g>
    <path
      fill="#C0C0C0"
      d="M236.568,139.336c0,0-97.493,2.738-117.712,5.3c0,0,104.113-4.667,117.864-4.118
	C236.721,140.518,236.803,139.329,236.568,139.336z"
    />
    <polygon fill="#939393" points="32.586,112.024 38.703,105.837 34.928,114.452 32.422,114.452 32.422,112.187 " />
    <path
      d="M101.8,185.496c5.185-3.27,8.934-13.169,8.934-24.852c0-14.367-5.685-26.013-12.697-26.013S85.34,146.277,85.34,160.644
	c0,11.101,3.394,20.578,8.172,24.313c0,0,7.021,2.709,16.605,0.631"
    />
    <ellipse fill="#939393" cx="97.082" cy="160.781" rx="9.409" ry="19.354" />
    <g>
      <path
        fill="#505050"
        d="M104.888,152.717l-0.893-2.91c0,0-2.093,1.685-1.532,6.076
		C102.462,155.883,104.573,153.447,104.888,152.717z"
      />
      <path fill="#505050" d="M100.777,145.289l-0.97,5.897l-0.434-5.616C99.373,145.569,99.654,145.135,100.777,145.289z" />
      <path fill="#505050" d="M96.157,146.59l0.786,5.412l-2.011-4.978C94.931,147.024,95.34,146.59,96.157,146.59z" />
      <path fill="#505050" d="M93.553,152.13l2.384,4.136c0,0-2.001,0.179-3.992-2.783l1.276-0.306L93.553,152.13z" />
      <path fill="#505050" d="M92.43,158.589l2.246,1.251c0,0,0.689,0.689-0.255,1.225c-0.945,0.536-1.991,1.302-1.991,1.302V158.589z" />
      <path
        fill="#505050"
        d="M105.653,158.589c0,0,0.408,3.676,0,5.131c0,0-2.042-1.481-2.425-2.068c0,0,0.306-1.532,0-2.144
		L105.653,158.589z"
      />
      <path
        fill="#505050"
        d="M104.824,169.349l-2.457-3.306c0,0-0.236,3.421,1.423,6.229
		C103.79,172.272,104.671,170.728,104.824,169.349z"
      />
      <path
        fill="#505050"
        d="M100.841,176.14c0,0-0.574-4.308-1.072-5.131c0,0-0.574,2.508-0.421,4.882
		C99.348,175.891,99.424,176.312,100.841,176.14z"
      />
      <path fill="#505050" d="M96.265,174.244v-3.676l-1.455,3.408C94.81,173.976,95.097,174.302,96.265,174.244z" />
      <path
        fill="#505050"
        d="M93.508,168.845l1.799-4.05c0.041-0.092-0.065-0.181-0.148-0.123l-3.451,2.374l1.474,0.364L93.508,168.845z
		"
      />
    </g>
    <ellipse fill="#505050" cx="98.244" cy="160.732" rx="1.078" ry="2.274" />
    <ellipse fill="#939393" cx="13.81" cy="150.018" rx="5.858" ry="14.934" />
    <g>
      <path fill="#505050" d="M9.952,144.597l0.458-2.385c0,0,1.456,1.285,1.283,4.855C11.693,147.067,10.192,145.176,9.952,144.597z" />
      <path fill="#505050" d="M11.582,138.451l1.382,4.614l-0.431-4.535C12.533,138.53,12.294,138.212,11.582,138.451z" />
      <path fill="#505050" d="M14.924,138.364l-0.275,4.403l1.102-4.097C15.752,138.67,15.463,138.334,14.924,138.364z" />
      <path fill="#505050" d="M17.007,142.747l-1.386,3.43c0,0,1.327,0.071,2.506-2.395l-0.698-0.626L17.007,142.747z" />
      <path
        fill="#505050"
        d="M18.723,147.229l-1.425,1.093c0,0-0.423,0.582,0.223,0.981c0.647,0.399,1.371,0.979,1.371,0.979
		L18.723,147.229z"
      />
      <path
        fill="#505050"
        d="M9.969,149.058c0,0-0.104,2.986,0.231,4.148c0,0,1.28-1.272,1.506-1.76c0,0-0.271-1.227-0.096-1.733
		L9.969,149.058z"
      />
      <path fill="#505050" d="M10.556,157.14l1.836-2.535c0,0-0.071,2.773-1.349,4.949C11.043,159.554,10.566,158.26,10.556,157.14z" />
      <path
        fill="#505050"
        d="M13.282,162.42c0,0,0.185-3.503,0.476-4.187c0,0,0.491,2.006,0.497,3.931
		C14.255,162.164,14.224,162.508,13.282,162.42z"
      />
      <path fill="#505050" d="M16.484,160.721l-0.165-2.971l1.112,2.701C17.431,160.451,17.256,160.724,16.484,160.721z" />
      <path
        fill="#505050"
        d="M17.98,156.111l-1.368-3.208c-0.031-0.073,0.035-0.148,0.092-0.105l2.381,1.792l-0.955,0.348L17.98,156.111
		z"
      />
    </g>
    <ellipse fill="#505050" cx="14.65" cy="149.935" rx="0.873" ry="1.841" />
    <path
      fill="#929296"
      d="M26.842,160.312c0,0-3.183-9.223-4.281-18.215s-5.217-15.856-5.217-15.856s-3.331-6.106-7.345-1.922
	c0,0-8.374,7.551-2.059,31.987c0,0-4.331-14.474-0.404-25.336c0,0,1.487-5.232,5.483-5.473c0,0,2.181-0.503,4.824,5.52
	c0,0,1.669,4.144,3.043,10.565l2.914,13.93C23.801,155.512,24.327,158.964,26.842,160.312z"
    />
    <path
      fill="#929296"
      d="M123.015,169.073c0,0-4.357-2.711-7.102-14.569c-2.746-11.858-11.575-31.011-21.142-29.293
	c-10.319,1.853-11.559,12.378-11.559,12.378s-3.931,17.137,2.911,32.17c0,0-6.246-18.842,0.292-33.9c0,0,2.38-5.898,8.56-6.694
	c0,0,4.383-0.679,8.645,5.577c0,0,5.36,6.901,8.175,17.39c0,0,4.213,17.07,8.657,18.794l7.45-0.197
	C127.901,170.729,124.784,170.325,123.015,169.073z"
    />
    <path
      fill="#C0C0C0"
      d="M205.204,118.889l-18.601,0.311c-0.687,0.011-1.204,0.629-1.095,1.307l1.353,11.378
	c0.126,0.786,0.816,1.356,1.611,1.334l18.363-0.52c0.654-0.018,1.146-0.601,1.055-1.249l-1.648-11.675
	C206.169,119.26,205.724,118.88,205.204,118.889z"
    />
    <path
      fill="#DCDCDC"
      d="M174.262,113.756l42.559,0.037c0,0-1.828,0.814-5.536,0.66l-34.67-0.004
	C176.615,114.449,174.329,114.355,174.262,113.756z"
    />
    <path fill="#DCDCDC" d="M224.017,105.157c0,0-12.416-7.814-76.598,1.543h79.246L224.017,105.157z" />
    <path
      fill="#939393"
      d="M118.857,81.795c0,0,13.724,11.036,16.654,13.748c2.931,2.712,5.454,2.123,5.454,2.123
	c24.551-1.498,66.802-0.806,66.802-0.806l-32.14-14.288C143.987,78.447,118.857,81.795,118.857,81.795z M122.754,82.681
	c0,0,23.395-2.908,52.395,0.873l27.367,11.958c0,0-38.097-0.926-60.599,0.447c0,0-2.313,0.539-4.999-1.946
	C134.231,91.528,122.754,82.681,122.754,82.681z"
    />
    <path
      fill="#505050"
      d="M130.168,116.696c-0.107,3.403,0.895,4.441,0.895,4.441c5.767,6.196,25.108,3.832,30.015,3.116
	c4.907-0.716,7.808-9.384,7.808-9.384h-17.873H130.16L130.168,116.696z"
    />
    <path
      fill="#505050"
      d="M231.664,116.038c-1.023,0.017-12.309-0.024-12.309-0.024l0.592,1.494c2.643,7.205,6.541,6.785,6.541,6.785
	s5.059,0.032,6.504,0s1.605-1.357,1.605-1.357v-6.922L231.664,116.038z"
    />
    <path
      d="M16.365,169.798c-5.445,0-9.859-9.136-9.859-20.406s4.414-20.406,9.859-20.406l-0.614,2.746c0,0-9.139,2.517-8.224,20.398
	c0,0,1.072,14.471,8.224,15.501L16.365,169.798z"
    />
    <polygon fill="#939393" points="62.958,109.565 62.869,109.796 43.023,112.115 43.054,111.765 " />
    <path
      fill="#939393"
      d="M32.124,114.777c0,0,26.517-2.087,68.71-9.678c0,0,15.381-2.38,24.269-11.367
	c0,0-21.694-15.68-46.234-12.434c-26.169,3.462-36.491,20.406-45.28,29.887L32.124,114.777z M36.403,110.041
	c8.146-8.786,17.847-23.733,42.1-26.942c22.743-3.009,42.832,11.2,42.832,11.2c-8.237,8.328-21.599,9.701-21.599,9.701
	c-39.103,7.036-63.333,8.695-63.333,8.695V110.041z"
    />
    <path
      d="M233.079,159.671c0,0,0.445-1.292-2.917-1.307c-3.362-0.016-52.57,1.87-52.57,1.87s-18.191,0.318-29.767,3.188
	c-11.575,2.87-22.431,7.402-22.431,7.402l70.587-2.651l34.682-1.536c0,0,3.212-0.37,2.16-5.877
	C232.825,160.76,232.61,159.876,233.079,159.671z"
    />
    <g>
      <path
        fill="#939393"
        d="M167.797,167.943l4.773-3.934c0.785-0.647,0.317-2.006-0.668-1.941c-5.952,0.39-18.627,1.555-25.142,4.651
		c-1.005,0.478-0.714,2.463,0.384,2.439l19.54-0.794C167.087,168.354,167.477,168.207,167.797,167.943z"
      />
      <g>
        <path
          d="M164.219,166.687l2.906-2.056c0.493-0.375,0.201-1.162-0.417-1.124c-3.738,0.232-11.696,0.921-15.79,2.722
			c-0.631,0.278-0.421,1.222,0.268,1.206l12.334-0.504C163.773,166.926,164.017,166.841,164.219,166.687z"
        />
      </g>
    </g>
    <g>
      <path
        fill="#939393"
        d="M221.904,165.588l7.469-0.271c0.818-0.018,1.641-0.521,1.766-1.33l0.106-0.682
		c0.19-1.227-0.428-2.444-1.637-2.727c-1.802-0.421-5.208-0.597-10.744-0.07c-0.482,0.046-0.753,0.585-0.519,1.009l2.043,3.201
		C220.693,165.267,221.277,165.602,221.904,165.588z"
      />
      <g>
        <path
          d="M222.852,164.771l5.525-0.201c0.575-0.013,1.088-0.361,1.176-0.929l0.074-0.479c0.133-0.862-0.411-1.689-1.26-1.888
			c-1.266-0.296-3.53-0.498-7.431-0.018c-0.338,0.042-0.529,0.411-0.364,0.709l1.216,2.195
			C222.001,164.546,222.411,164.781,222.852,164.771z"
        />
      </g>
    </g>
    <path
      d="M64.174,109.198c0,0-5.384,6.717-4.533,8.267c0.85,1.55,1.867,1.867,1.867,2.933c0,1.067-3.733,25.6,0.533,33.067
	c0,0-2.667,2.933-1.867,3.733c0.8,0.8-0.267,4-2.4,3.733c-2.133-0.267-24.533-3.2-24.533-3.2l-0.533-4c0,0,2.667-1.6,2.4-2.667
	s-3.866-18.135-0.466-28.667c0,0-0.83-1.204-1.134-3.332c-0.533-3.733,2.4-5.333,2.4-5.333l1.333-2.933L64.174,109.198z"
    />
    <path
      fill="#939393"
      d="M36.592,113.665c0,0,3.4-0.8,3.8,4.2s0,29.8,0,32s-2.703,7.533-7.152,7.867c0,0-1.448-38.267-1.248-40.067
	S32.792,114.265,36.592,113.665z"
    />
    <path
      fill="#939393"
      d="M27.669,112.727v-5.835c0,0-0.412-1.647-1.716-1.476c-1.304,0.172-5.8,1.407-6.212,2.814
	c0,0,0.137,4.633,2.505,4.942C22.247,113.174,26.777,113.688,27.669,112.727z"
    />
    <path
      fill="#505050"
      d="M31.846,113.198c0,0,2.187,3.467,2.551,9.333c0.364,5.867,0,27.467,0,29.067s0,4.267-2.551,6.133
	c-2.551,1.867-24.054,6.933-24.054,6.933l3.28-53.067L31.846,113.198z"
    />
    <path
      fill="#939393"
      d="M6.77,111.413c0,0-5.195,6.864-4.301,8.39c0.893,1.526,1.918,1.814,1.948,2.88
	c0.03,1.066-3.019,25.694,1.454,33.039c0,0-2.584,3.006-1.762,3.784c0.822,0.777-1.725,5.117,3.606,4.968
	c2.149-0.06,2.902-1.148,4.724-2.799c6.147-5.573,6.135-47.923,0.492-49.366S6.77,111.413,6.77,111.413z"
    />
    <path
      fill="#C0C0C0"
      d="M8.08,111.376c0,0-4.47,6.844-3.691,8.373c0.779,1.529,1.667,1.821,1.696,2.887
	c0.03,1.066-2.517,25.68,1.382,33.041c0,0-2.225,2.996-1.511,3.777s-1.474,5.11,3.14,4.981c1.86-0.052,2.508-1.137,4.078-2.781
	c5.299-5.549,5.13-47.895,0.241-49.359S8.08,111.376,8.08,111.376z"
    />
    <path
      fill="#505050"
      d="M31.992,113.465c0,0-3.791-22.4-11.445-27.2c-7.654-4.8-13.649-6.267-13.649-6.267s-1.822-0.533-1.458,1.333
	c0.364,1.867,1.676,30.045,1.676,30.045l7.292,0.918l-3.017-27.43c0,0,5.146,2.467,6.969,4.6c1.822,2.133,6.56,8,9.111,23.733
	L31.992,113.465z"
    />
    <g id="Sedan-White">
      <polygon
        opacity="0.5"
        fill="#2D2D2D"
        points="377.801,146.555 363.394,135.242 323.111,131.663 250.139,133.103 224.698,154.159 
		216.416,161.515 309.425,164.703 375.741,157.628 380.338,152.378 	"
      />
      <path
        fill-opacity="0.252"
        d="M399.032,218.956c0.74-0.241,1.42-6.471,0.646-6.562l-65.458-5.951
		c-0.106-0.043,2.494,0.589,2.38,0.595l-67.714-3.219c-0.104-0.01-0.21,0.003-0.309,0.037L223.845,219.2
		c-0.059,0.02-0.119,0.037-0.18,0.05L155.7,237.386c-1.609,0.337-1.567,2.648,0.053,2.927l70.048,7.082
		c1.021,0.176,2.054,0.274,3.089,0.295l64.503,1.28c1.999,0.04,3.994-0.195,5.928-0.699l47.749-12.422
		c0.029-0.008,0.058-0.016,0.087-0.025L399.032,218.956z"
      />
      <polygon
        points="396.35,170.337 398.27,188.59 395.802,198.853 374.921,207.627 312.995,223.804 274.509,229.952 286.673,186.826 
		298.892,179.85 326.431,174.175 367.286,168.187 	"
      />
      <path
        d="M299.22,189.475c-3.648,0-15.147,0-18.795,0c-7.499,0-13.578,12.746-13.578,28.469c0,15.723,6.079,28.469,13.578,28.469
		c3.648,0,15.146,0,18.795,0c7.499,0,13.578-12.746,13.578-28.469C312.798,202.221,306.719,189.475,299.22,189.475z"
      />
      <ellipse fill="#939393" cx="301.112" cy="218.642" rx="8.313" ry="21.113" />
      <path
        d="M387.232,178.489c-2.22,0-9.215,0-11.434,0c-4.562,0-8.261,9.375-8.261,20.94s3.698,20.94,8.261,20.94
		c2.219,0,9.215,0,11.434,0c4.562,0,8.261-9.375,8.261-20.94S391.794,178.489,387.232,178.489z"
      />
      <ellipse fill="#939393" cx="388.383" cy="199.942" rx="5.057" ry="15.53" />
      <ellipse fill="#2D2D2D" cx="189.179" cy="231.656" rx="16.268" ry="5.859" />
      <path
        d="M344.063,128.842l3.565,5.849c0,0,3.108-0.457,6.032,0.64c1.419,0.532,3.568,1.537,5.406,2.431
		c2.296,1.117,4.304,2.744,5.87,4.761l2.548,3.282c0.214,0.276,0.018,0.677-0.332,0.677h-5.372c-0.729,0-1.4-0.399-1.748-1.04
		l-0.841-1.549c-0.476-0.877-1.41-1.406-2.407-1.363l-4.769,0.204l3.29,11.516l24.312-1.005l1.737-0.473l1.371-5.468l-7.719-7.495
		l-8.184-4.753l-12.247-4.57L344.063,128.842z"
      />
      <path
        d="M341.465,128.446c0,0,4.71,8.042,6.549,12.465c1.838,4.423,3.389,14.131,3.389,14.131s-21.535,2.585-28.259,2.585
		c-6.724,0-5.518-1.953-5.518-1.953l4.825-14.591l1.494-0.862c0,0,2.528-0.115,4.481-0.115s2.47-0.23,3.447,0.747
		c0.977,0.977,2.183,3.617,2.183,3.617h3.562l2.47,2.243l2.183-0.057c0,0-1.264-6.836-5.342-12.121h-9.938
		c0,0,2.642-3.564,6.606-4.597C337.559,128.906,341.465,128.446,341.465,128.446z"
      />
      <path
        d="M323.144,129.939c0,0-13.08-0.714-16.279-0.714c-3.199,0-23.855,0-23.855,0s-15.72,0.415-19.468,0.415
		c-3.747,0-8.043,0.298-10.511,0.298s-6.215,1.188-6.215,1.188l-15.629,10.419l-16.726,13.71c-1.554,1.554-1.371,2.372-1.371,2.372
		c4.479,1.55,31.715,1.375,36.285,1.375c4.57,0,63.796,0,63.796,0l11.059-27.876L323.144,129.939z M259.657,137.113
		c0,0-3.153,4.89-4.89,8.317c-1.737,3.427-3.702,8.546-3.702,8.546s-6.672,0.137-13.664,0.823
		c-6.992,0.685-12.704,1.462-12.704,1.462v-2.102c0,0,7.723-6.718,13.161-10.237c5.438-3.519,9.048-5.393,11.562-6.535
		c2.513-1.142,5.53-2.376,10.739-2.605L259.657,137.113z M274.418,137.296c0,0,0,0-0.823,0c-0.823,0-1.112,1.417-1.112,1.417
		l-0.076,1.874c0,0,0,0-0.685,0c-0.685,0-0.914,0.686-0.914,0.686s0.046,1.508,0.046,2.845c0,1.337,0.685,2.913,0.685,2.913
		l0.091,1.737c0,0-2.285,0.32-3.382,1.005c-1.097,0.685-1.919,3.153-1.919,3.153h-1.645c0,0,0-1.371,0-2.376
		c0-1.005,0.457-1.737,0.457-1.737s5.027-9.368,5.941-11.105c0.914-1.737,3.427-1.737,3.427-1.737L274.418,137.296z M286.62,143.097
		c0,0-1.645-2.054-3.108-2.054c0-0.274-0.046-0.548-0.046-0.548h0.443c0.689,0,1.248-0.559,1.248-1.248v-0.74
		c0-0.972-0.788-1.76-1.76-1.76h-6.375v-1.005c0,0,4.89-0.366,7.22,0c2.331,0.366,4.067,1.691,4.067,1.691
		C287.266,138.766,286.751,140.711,286.62,143.097z M298.862,147.526c-0.13,0.824-0.676,1.523-1.413,1.915
		c-0.726,0.387-1.867,0.967-2.832,1.336c-1.554,0.594-2.034,0.251-2.285,0c-0.251-0.251-0.457-2.468-0.228-4.616
		c0.111-1.041,0.468-2.285,0.807-3.291c0.3-0.89,1.425-1.159,2.093-0.5c0.989,0.976,2.293,2.267,3.178,3.151
		C298.848,146.188,298.959,146.91,298.862,147.526z M317.956,136.3c-0.517,1.419-1.422,3.901-1.678,4.606
		c-0.174,0.477-0.368,0.995-0.524,1.408c-0.178,0.471-0.632,0.776-1.135,0.766l-1.606-0.033c-0.311-0.006-0.61-0.124-0.843-0.33
		l-6.786-6.03c-0.32-0.285-0.162-0.814,0.263-0.872c1.469-0.202,4.188-0.529,6.427-0.529h5.17
		C317.77,135.285,318.137,135.806,317.956,136.3z"
      />
      <path
        fill="#EBEBEB"
        d="M402.922,177.809c-0.446-1.302-1.141-3.521-1.141-4.731c0-1.367-0.377-10.29-0.552-14.373
		c-0.05-1.166-0.951-2.117-2.113-2.231l-1.501-0.146l-0.693-0.068c-0.071-0.007-0.137-0.035-0.191-0.081l-9.695-8.223
		c-0.01-0.008-0.018-0.016-0.027-0.025c-0.341-0.362-8.053-8.503-16.988-13.149c-9.14-4.753-17.366-8.226-26.688-9.323
		c-9.323-1.097-19.011-1.462-23.581-1.462c-4.57,0-26.14,0.183-42.957,1.28c-16.817,1.097-25.58,3.215-28.882,4.753
		c-14.759,6.875-25.982,16.619-29.064,19.433c-0.188,0.172-0.489,0.089-0.565-0.154l0,0c-0.281-0.894-1.11-1.503-2.047-1.503h-0.617
		c-0.843,0-1.67,0.234-2.388,0.675l-3.284,2.017c-1.381,0.848-1.884,2.611-1.16,4.06l0.197,0.394
		c0.17,0.339,0.399,0.634,0.672,0.876c0.22,0.196,0.094,0.562-0.198,0.597c-2.21,0.268-6.182,0.772-10.032,1.368
		c-5.755,0.891-22.258,4.588-29.189,6.919c-0.009,0.003-0.016,0.006-0.025,0.009c-0.371,0.157-9.283,3.957-15.59,10.25
		c-0.018,0.018-0.039,0.034-0.061,0.048l-5.895,3.617c-0.068,0.042-0.119,0.104-0.146,0.179c-0.184,0.521-0.919,2.695-0.919,4.135
		c0,1.409,0.503,3.249,0.647,3.747c0.025,0.085,0.016,0.172-0.024,0.251c-0.596,1.165-5.297,10.44-6.441,15.362
		c-0.006,0.027-0.009,0.054-0.01,0.081c-0.118,7.161,5.96,8.537,3.771,14.01c-0.69,1.725-1.176,3.016-1.519,3.975
		c-0.607,1.698-0.255,3.596,0.931,4.955c0.327,0.375,0.705,0.783,1.137,1.215c2.056,2.056,23.301,8.773,66.888,10.145
		c0.01,0,0.019,0.001,0.029,0.002c0.682,0.083,27.074,3.267,43.583,1.644c14.714-1.447,21.44-2.592,22.845-2.846
		c0.166-0.03,0.285-0.174,0.284-0.343l-0.006-2.934c0.26-6.05,0.646-9.481,1.77-17.058c2.434-16.394,12.131-31.508,21.03-30.469
		c8.899,1.039,12.844,13.07,13.85,32.629c0.165,3.203-0.375,7.409-0.579,8.847c-0.035,0.244,0.188,0.443,0.427,0.385l2.16-0.526
		c0.062-0.015,0.119-0.047,0.164-0.092l2.24-2.24c0.044-0.044,0.1-0.076,0.16-0.091l43.769-11.125
		c0.006-0.002,0.012-0.003,0.018-0.005l13.661-4.264c0.154-0.048,0.255-0.196,0.243-0.357l-0.111-1.531
		c-0.001-0.012-0.002-0.022-0.004-0.033c-0.037-0.207-0.427-2.529,0.267-4.609c0.707-2.12,1.226-6.426,1.254-6.662
		c0.001-0.007,0.002-0.013,0.003-0.019c0.076-0.424,2.779-15.315,7.793-19.743c5.087-4.492,8.126,1.916,8.126,5.681
		s-0.396,8.833,0,10.891c0.262,1.362,0.09,5.843-0.324,9.236c-0.04,0.324,0.351,0.52,0.585,0.293
		c1.835-1.771,4.049-4.684,4.92-8.942c1.166-5.698,1.774-10.302,2.017-12.378C403.246,179.281,403.167,178.523,402.922,177.809z
		 M312.428,157.593c-0.049,0.135-0.173,0.225-0.316,0.229c-3.472,0.093-44.31,1.182-57.345,1.182c-12.983,0-34.635-1.372-40.4-1.954
		c-0.294-0.03-0.419-0.388-0.208-0.594c3.511-3.42,12.222-11.194,18.032-15.183c6.124-4.204,13.527-8.957,15.081-9.505
		c1.554-0.548,8.957-1.828,36.194-1.828c24.149,0,36.802,1.006,39.36,1.234c0.24,0.021,0.385,0.271,0.285,0.49
		c-0.819,1.782-3.899,8.504-5.553,12.443C315.815,148.254,312.943,156.169,312.428,157.593z M348.385,154.86
		c-0.209,0.027-0.395-0.136-0.392-0.346c0.008-0.557-0.066-1.564-0.639-2.137c-0.823-0.823-7.952-3.633-11.927-4.044
		c-3.976-0.411-6.444,0.891-8.5,2.948c-2.056,2.056-1.714,3.633-1.714,3.633l-0.018,1.712c-0.002,0.191-0.157,0.344-0.348,0.344
		h-6.171c-0.23,0-0.397-0.217-0.336-0.438c0.9-3.271,6.858-23.653,14.002-25.884c6.118-1.911,9.129-1.343,9.129-1.343
		s3.045,5.437,4.718,9.158c2.961,6.586,4.164,14.077,4.407,15.761c0.028,0.192-0.108,0.368-0.301,0.393L348.385,154.86z
		 M356.389,153.877c-0.179,0.006-0.331-0.123-0.354-0.301c-0.19-1.488-1.468-5.663-2.101-7.437
		c-0.686-1.919-2.445-6.856-3.141-8.316c-0.696-1.46-1.669-3.269-1.669-3.269c-0.339-0.641-1.859-3.198-2.569-4.388
		c-0.15-0.251,0.057-0.562,0.346-0.522c1.539,0.214,5.408,0.819,10.049,2.031c3.125,0.817,6.617,2.443,9.753,4.164
		c0.041,0.022,0.075,0.051,0.105,0.087c1.878,2.346,6.163,8.37,8.104,16.549c0.05,0.211-0.103,0.417-0.319,0.429
		C368.223,153.265,358.49,153.806,356.389,153.877z M380.038,152.595c-0.425,0.024-1.445,0.083-2.834,0.162
		c-0.16,0.009-0.306-0.09-0.353-0.243c-0.627-2.034-2.75-8.143-7.213-14.198c-0.227-0.309,0.132-0.707,0.459-0.507
		c1.516,0.928,2.841,1.802,3.855,2.504c3.293,2.28,7.288,6.725,7.878,7.388c0.072,0.082,0.102,0.189,0.081,0.296
		c-0.162,0.796-1.261,3.599-1.571,4.382C380.288,152.504,380.173,152.587,380.038,152.595z"
      />
      <path
        d="M242.612,186.826c0,0-38.913,2.278-64.16,1.211c-15.761-0.666-27.695-4.265-27.695-4.265v3.054l16.14,9.983
		c3.557,2.2,6.185,5.627,7.386,9.633l0.455,1.516c0.294,0.981,1.17,1.674,2.192,1.735l5.06,0.303
		c1.006,0.06,1.946-0.505,2.365-1.421l0,0c2.314-5.063,6.948-8.683,12.42-9.704l45.653-8.517L242.612,186.826z"
      />
      <path
        fill="#C0C0C0"
        d="M142.343,205.95l15.88,6.342c0.324,0.155,0.613,0.343,0.857,0.557l7.332,6.441
		c0.649,0.57,1.595,0.936,2.631,1.019l14.624,1.167c1.112,0.089,2.226-0.158,3.062-0.678l9.809-6.103
		c0.626-0.39,1.414-0.629,2.249-0.684l64.314-4.054c1.657-0.108,3.231,0.524,3.931,1.578l5.561,12.413
		c1.103,1.659-0.385,3.593-2.975,3.868l-17.103,3.528c-0.135,0.014-0.269,0.024-0.406,0.028c-2.546,0.083-28.113,0.895-29.404-0.007
		c-1.286-0.898-31.052-0.975-34.21-0.981c-0.181,0-0.361-0.009-0.541-0.027l-26.212-2.596c-0.147-0.015-0.293-0.035-0.437-0.061
		l-16.637-9.058L142.343,205.95z"
      />
      <path
        fill="#C9C9C9"
        d="M155.181,197.574c-0.609-0.61-5.973-6.01-6.727-7.724c-1.047-2.379-0.151-8.752-0.046-9.471l1.207-0.083
		c0.199,0.687,4.004,9.234,6.513,14.812l0.054,0.235l0.055,1.773L155.181,197.574z"
      />
      <path
        fill="#FFFFFF"
        d="M149.02,179.85c0,0-1.005,6.846,0,9.131c0.729,1.657,6.599,7.536,6.599,7.536l-0.055-1.773
		C155.563,194.744,149.304,180.828,149.02,179.85z"
      />
      <path
        fill="#FFFFFF"
        d="M173.967,194.53c1.434,1.704,3.118,3.957,4.048,6.089c0.421,0.965,1.733,1.085,2.317,0.209
		c1.131-1.696,2.79-3.889,4.755-5.585c0.927-0.8,0.366-2.321-0.859-2.321c-3.186-0.001-6.223-0.18-9.089-0.559
		C173.944,192.206,173.191,193.609,173.967,194.53z"
      />
      <path
        d="M262.217,212.977l-29.789,3.051c-0.619,0.063-1.187,0.372-1.577,0.857l-4.267,5.305c-0.955,1.187-0.531,2.956,0.859,3.582
		l4.023,1.81c0.356,0.16,0.747,0.228,1.137,0.198l33.619-2.626c1.628-0.127,2.622-1.846,1.921-3.321l-3.587-7.539
		C264.133,213.404,263.196,212.877,262.217,212.977z"
      />
      <path
        d="M141.838,203.804c0,0,6.177,6.2,7.457,8.576c0.97,1.802,2.251,4.34,2.814,5.461c0.174,0.346,0.121,0.762-0.131,1.055l0,0
		c-0.395,0.459-1.111,0.442-1.484-0.034l-4.616-5.897C145.877,212.965,141.602,206.379,141.838,203.804z"
      />
      <path
        fill="#DCDCDC"
        d="M364.728,212.616l13.661-4.264c0.154-0.048,0.255-0.196,0.243-0.357l-0.111-1.531
		c-0.001-0.012-0.002-0.022-0.004-0.033c-0.037-0.207-0.427-2.529,0.267-4.609c0.707-2.12,1.226-6.426,1.254-6.662
		c0.001-0.007,0.002-0.013,0.003-0.019c0.076-0.424,2.779-15.315,7.793-19.743c5.087-4.492,8.126,1.916,8.126,5.681
		c0,3.766-0.396,8.833,0,10.891c0.262,1.362,0.09,5.843-0.324,9.236c-0.04,0.324,0.351,0.52,0.585,0.293
		c1.835-1.771,4.049-4.684,4.92-8.942c1.166-5.698,1.774-10.302,2.017-12.378c0.088-0.749,0.008-1.508-0.236-2.222
		c-0.288-0.84-0.678-2.061-0.92-3.148l-4.859,3.988c0,0,0-7.223-6.772-7.223c-6.772,0-10.534,12.49-10.534,12.49l-65.009,10.993
		c-2.107-8.126-8.879-12.649-15.048-11.746c-19.712,3.105-21.375,44.126-21.509,52.526c0.546-0.09,0.934-0.158,1.169-0.2
		c0.166-0.03,0.285-0.174,0.284-0.343l-0.006-2.934c0.26-6.05,0.646-9.481,1.77-17.058c2.434-16.394,12.131-31.508,21.03-30.469
		c8.899,1.039,12.844,13.07,13.85,32.629c0.165,3.203-0.375,7.409-0.579,8.847c-0.035,0.244,0.188,0.443,0.427,0.385l2.16-0.526
		c0.062-0.015,0.119-0.047,0.164-0.092l2.24-2.24c0.044-0.044,0.1-0.076,0.16-0.091l43.769-11.125
		C364.716,212.62,364.722,212.618,364.728,212.616z"
      />
      <path fill="#DCDCDC" d="M283.286,178.2c0,0,43.145-14.855,75.089-18.009c31.944-3.153,34.823-1.188,34.823-1.188" />
      <polygon
        points="349.695,164.892 357.279,164.172 357.588,164.892 357.588,167.02 349.695,168.187 348.872,167.706 
		348.872,165.613 	"
      />
      <path
        d="M376.38,161.974c0,0,1.828-0.457,3.656-0.731c1.828-0.274,3.29,0,3.29,0l-0.366,1.417c0,0-1.417,0.503-3.108,0.777
		c-1.691,0.274-2.925,0.274-2.925,0.274L376.38,161.974z"
      />
      <path
        d="M216.416,204.259l-10.026,16.64c-2.083,3.458-6.107,5.391-10.232,4.916l-26.969-3.104
		c-4.394-0.506-7.973-3.631-8.921-7.788l-4.053-17.774C171.363,207.474,193.647,206.259,216.416,204.259z"
      />
      <path
        fill="#C0C0C0"
        d="M331.446,217.944c0,0,28.842-11.612,34.061-13.839c5.219-2.227,9.366-1.547,7.417,0.986
		C370.974,207.625,342.983,215.802,331.446,217.944z"
      />
      <g>
        <path
          d="M376.861,152.51c-0.627-2.034-2.75-8.143-7.213-14.198c-0.214-0.29,0.09-0.652,0.399-0.53l-3.332-1.946
			c0.041,0.022,0.075,0.051,0.105,0.087c1.878,2.346,6.163,8.37,8.104,16.549c0.05,0.211-0.103,0.417-0.319,0.429
			c-0.229,0.013-0.464,0.026-0.702,0.04l3.896-0.187l0.002-0.034c-0.188,0.011-0.382,0.022-0.586,0.033
			C377.055,152.762,376.908,152.663,376.861,152.51z"
        />
        <path d="M370.471,138.029l-0.001-0.001l-0.018-0.011C370.458,138.021,370.464,138.025,370.471,138.029z" />
        <path
          d="M356.047,153.572c-0.19-1.488-1.468-5.663-2.101-7.437c-0.685-1.919-2.445-6.856-3.141-8.316
			c-0.696-1.461-1.669-3.269-1.669-3.269c-0.339-0.641-1.859-3.198-2.569-4.388c-0.145-0.243,0.045-0.541,0.321-0.522
			c-0.916-0.14-2.069-0.302-3.197-0.419c-1.264-0.131-2.19-0.069-2.789,0.019c0.386,0.023,0.58,0.06,0.58,0.06
			s3.045,5.437,4.718,9.158c2.961,6.586,4.164,14.077,4.407,15.761c0.028,0.192-0.108,0.368-0.301,0.393l6.094-0.738
			C356.221,153.879,356.069,153.75,356.047,153.572z"
        />
      </g>
      <path
        fill="#C0C0C0"
        d="M278.436,180.374l3.429-1.134c0,0,2.245,13.185-8.903,15.932c-11.149,2.747-38.548,6.521-39.029,7.002
		l-9.456-3.488c-0.832-0.307-1.099-1.351-0.517-2.02l2.982-3.424l14.475-3.092l34.688-6.378L278.436,180.374z"
      />
      <path
        fill="#FFFFFF"
        stroke="#FFFFFF"
        strokeWidth="1.1158"
        stroke-miterlimit="10"
        d="M262.897,184.63
		c2.484-0.4,5.912-0.946,9.945-2.085c3.93-1.11,5.792-2.451,7.135-2.769c0.105-0.025,0.206,0.051,0.22,0.158
		c0.083,0.629,0.186,2.48-0.919,4.973c-0.715,1.613-1.356,6.013-11.182,8.432l-33.053,7.11l-7.143-2.575
		c-0.4-0.144-0.468-0.681-0.117-0.921l14.828-10.128L262.897,184.63z"
      />
      <path
        fill="#C0C0C0"
        d="M347.667,155.024l-3.161,2.802c-1.494,1.324-3.421,2.055-5.418,2.055H324.23l-7.825,0.872
		c0,0-0.412-2.999,0.374-3.784h8.068l3.328-0.513c0,0,8.096,0,11.645-0.374C343.37,155.709,347.667,155.024,347.667,155.024z"
      />
      <g>
        <path
          d="M302.301,203.447l-1.75-1.273h-2.156c0,0-1.624,3.056-2.031,4.736c-0.344,1.171-0.344,1.171-0.344,1.171l0.75,0.255
			l-0.156,3.412l-1.468,3.62l-0.312,0.352c0,0-0.344,6.57,1.062,11.765c0.203,0.331,1.624,0.458,1.624,0.458l0.625,2.394
			l0.968,4.176c0,0,1.312,1.324,2.499,1.324s2.53-0.866,2.53-0.866l0.156-3.31l2.312-2.394l0.625-0.356c0,0,1.383-6.57,1.383-9.906
			c-0.599-0.976-1.321-1.856-1.321-1.856l-0.031-6.216l0.094-3.276c0,0-2.062-4.873-3.124-5.484
			c-0.672,1.095-1.156,1.884-1.156,1.884L302.301,203.447z"
        />
        <path
          fill="#505050"
          d="M302.808,218.03c0-1.424-0.474-2.578-1.058-2.578s-1.058,1.154-1.058,2.578
			c0,1.424,0.474,2.578,1.058,2.578S302.808,219.453,302.808,218.03z"
        />
      </g>
      <g>
        <path
          d="M389.089,189.423l-1.003-0.914h-1.235c0,0-0.931,2.193-1.164,3.399c-0.197,0.841-0.197,0.841-0.197,0.841l0.43,0.183
			l-0.09,2.449l-0.841,2.598l-0.179,0.253c0,0-0.197,4.715,0.609,8.442c0.116,0.238,0.931,0.329,0.931,0.329l0.358,1.718
			l0.555,2.997c0,0,0.752,0.95,1.432,0.95s1.45-0.621,1.45-0.621l0.089-2.376l1.325-1.718l0.358-0.256c0,0,0.793-4.715,0.793-7.108
			c-0.343-0.701-0.757-1.332-0.757-1.332l-0.018-4.461l0.054-2.351c0,0-1.181-3.497-1.79-3.935
			c-0.385,0.786-0.662,1.352-0.662,1.352L389.089,189.423z"
        />
        <path
          fill="#505050"
          d="M389.38,199.887c0-1.022-0.271-1.85-0.606-1.85c-0.335,0-0.606,0.828-0.606,1.85
			c0,1.022,0.271,1.85,0.606,1.85C389.108,201.737,389.38,200.909,389.38,199.887z"
        />
      </g>
    </g>
    <path d="M40.992,112.065c0,0,7.4-6,14.2-6.2c6.8-0.2,11.2,0.8,11.2,0.8l-3.526,3.132L40.992,112.065z" />
    <line fill="none" stroke="#F3BC2A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" stroke-miterlimit="10" x1="51.359" y1="120.698" x2="51.459" y2="52.398" />
    <line fill="none" stroke="#F3BC2A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" stroke-miterlimit="10" x1="297.216" y1="154.106" x2="297.616" y2="99.198" />
    <g>
      <g>
        <path
          d="M272.789,51.691h6.426c1.568,0,2.961,0.305,4.179,0.914c1.218,0.609,2.163,1.47,2.835,2.583
			c0.672,1.113,1.008,2.398,1.008,3.854c0,1.457-0.336,2.741-1.008,3.854c-0.672,1.113-1.617,1.974-2.835,2.583
			c-1.218,0.609-2.611,0.914-4.179,0.914h-6.426V51.691z M279.089,64.082c1.078,0,2.026-0.207,2.846-0.62
			c0.819-0.413,1.449-1,1.89-1.764c0.441-0.763,0.662-1.648,0.662-2.657c0-1.008-0.22-1.893-0.662-2.656
			c-0.441-0.763-1.071-1.351-1.89-1.764c-0.819-0.413-1.768-0.62-2.846-0.62h-3.57v10.08H279.089z"
        />
        <path
          d="M296.371,55.052v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.297-2.394,0.892
			c-0.574,0.595-0.861,1.453-0.861,2.573v5.439h-2.625V55.178h2.499v1.638C293.137,55.64,294.468,55.052,296.371,55.052z"
        />
        <path
          d="M298.724,52.878c-0.322-0.301-0.483-0.675-0.483-1.124c0-0.448,0.161-0.822,0.483-1.124
			c0.322-0.301,0.721-0.451,1.197-0.451s0.875,0.144,1.197,0.43c0.322,0.287,0.483,0.648,0.483,1.082
			c0,0.462-0.158,0.851-0.473,1.166s-0.718,0.473-1.208,0.473C299.445,53.33,299.046,53.179,298.724,52.878z M298.598,55.178h2.625
			v11.214h-2.625V55.178z"
        />
        <path d="M315.167,55.178l-4.809,11.214h-2.709l-4.809-11.214h2.73l3.486,8.316l3.591-8.316H315.167z" />
        <path
          d="M326.99,61.625h-8.8c0.154,0.826,0.557,1.48,1.208,1.963c0.651,0.483,1.459,0.725,2.426,0.725
			c1.231,0,2.247-0.406,3.045-1.218l1.407,1.617c-0.504,0.602-1.141,1.058-1.911,1.365c-0.771,0.308-1.638,0.462-2.604,0.462
			c-1.232,0-2.317-0.245-3.255-0.735s-1.663-1.172-2.173-2.048c-0.511-0.875-0.767-1.865-0.767-2.971
			c0-1.092,0.249-2.076,0.746-2.951c0.497-0.875,1.187-1.557,2.068-2.047c0.882-0.49,1.876-0.735,2.982-0.735
			c1.092,0,2.068,0.241,2.929,0.724c0.861,0.483,1.533,1.163,2.016,2.037c0.483,0.875,0.725,1.887,0.725,3.035
			C327.032,61.03,327.017,61.289,326.99,61.625z M319.23,57.897c-0.581,0.497-0.935,1.159-1.061,1.985h6.363
			c-0.112-0.812-0.455-1.47-1.029-1.974s-1.288-0.756-2.142-0.756C320.521,57.151,319.811,57.4,319.23,57.897z"
        />
        <path
          d="M336.04,55.052v2.499c-0.224-0.042-0.427-0.063-0.608-0.063c-1.022,0-1.82,0.297-2.395,0.892
			c-0.574,0.595-0.86,1.453-0.86,2.573v5.439h-2.625V55.178h2.499v1.638C332.806,55.64,334.136,55.052,336.04,55.052z"
        />
        <path
          d="M344.965,66.182c-0.868-0.238-1.561-0.539-2.079-0.903l1.009-1.995c0.504,0.336,1.109,0.605,1.816,0.809
			c0.706,0.203,1.403,0.304,2.089,0.304c1.568,0,2.353-0.413,2.353-1.239c0-0.392-0.2-0.665-0.599-0.819
			c-0.399-0.154-1.04-0.301-1.922-0.441c-0.924-0.14-1.677-0.301-2.257-0.483c-0.581-0.182-1.086-0.5-1.513-0.956
			c-0.427-0.455-0.641-1.088-0.641-1.9c0-1.064,0.444-1.914,1.334-2.551c0.889-0.637,2.09-0.956,3.602-0.956
			c0.77,0,1.54,0.087,2.31,0.262c0.771,0.175,1.4,0.41,1.891,0.704l-1.009,1.995c-0.952-0.56-2.022-0.84-3.213-0.84
			c-0.77,0-1.354,0.116-1.753,0.347c-0.399,0.231-0.599,0.536-0.599,0.914c0,0.42,0.213,0.718,0.641,0.893
			c0.427,0.175,1.088,0.339,1.984,0.493c0.896,0.14,1.631,0.301,2.205,0.483c0.573,0.182,1.067,0.49,1.48,0.924
			c0.413,0.434,0.619,1.05,0.619,1.848c0,1.05-0.455,1.89-1.365,2.52c-0.91,0.63-2.148,0.945-3.717,0.945
			C346.721,66.539,345.833,66.42,344.965,66.182z"
        />
        <path
          d="M355.108,52.878c-0.322-0.301-0.483-0.675-0.483-1.124c0-0.448,0.161-0.822,0.483-1.124
			c0.321-0.301,0.721-0.451,1.196-0.451c0.477,0,0.875,0.144,1.197,0.43c0.322,0.287,0.483,0.648,0.483,1.082
			c0,0.462-0.158,0.851-0.473,1.166c-0.315,0.315-0.718,0.473-1.208,0.473C355.829,53.33,355.429,53.179,355.108,52.878z
			 M354.982,55.178h2.625v11.214h-2.625V55.178z"
        />
        <path
          d="M372.034,50.81v15.582h-2.521v-1.449c-0.434,0.532-0.97,0.932-1.606,1.197s-1.341,0.399-2.11,0.399
			c-1.078,0-2.048-0.238-2.908-0.714c-0.861-0.476-1.537-1.151-2.026-2.026c-0.49-0.875-0.735-1.88-0.735-3.014
			c0-1.134,0.245-2.135,0.735-3.003c0.489-0.868,1.165-1.54,2.026-2.016c0.86-0.476,1.83-0.714,2.908-0.714
			c0.742,0,1.421,0.126,2.037,0.378s1.141,0.63,1.575,1.134V50.81H372.034z M367.812,63.861c0.504-0.287,0.903-0.696,1.197-1.229
			s0.441-1.148,0.441-1.848s-0.147-1.316-0.441-1.848c-0.294-0.532-0.693-0.941-1.197-1.229c-0.504-0.287-1.07-0.43-1.7-0.43
			c-0.631,0-1.197,0.144-1.701,0.43c-0.504,0.287-0.903,0.697-1.197,1.229c-0.294,0.532-0.441,1.148-0.441,1.848
			s0.147,1.316,0.441,1.848s0.693,0.941,1.197,1.229s1.07,0.43,1.701,0.43C366.742,64.292,367.308,64.149,367.812,63.861z"
        />
        <path
          d="M385.977,61.625h-8.799c0.153,0.826,0.557,1.48,1.207,1.963c0.651,0.483,1.46,0.725,2.426,0.725
			c1.231,0,2.247-0.406,3.045-1.218l1.407,1.617c-0.504,0.602-1.142,1.058-1.911,1.365c-0.771,0.308-1.638,0.462-2.604,0.462
			c-1.232,0-2.317-0.245-3.256-0.735c-0.938-0.49-1.662-1.172-2.173-2.048c-0.512-0.875-0.767-1.865-0.767-2.971
			c0-1.092,0.248-2.076,0.745-2.951c0.497-0.875,1.187-1.557,2.068-2.047c0.883-0.49,1.876-0.735,2.982-0.735
			c1.092,0,2.068,0.241,2.93,0.724c0.86,0.483,1.533,1.163,2.016,2.037c0.483,0.875,0.725,1.887,0.725,3.035
			C386.019,61.03,386.006,61.289,385.977,61.625z M378.218,57.897c-0.581,0.497-0.935,1.159-1.061,1.985h6.363
			c-0.112-0.812-0.455-1.47-1.029-1.974s-1.288-0.756-2.142-0.756C379.51,57.151,378.799,57.4,378.218,57.897z"
        />
        <path
          d="M283.52,73.81v15.582H281v-1.449c-0.434,0.532-0.97,0.932-1.606,1.197c-0.637,0.266-1.341,0.399-2.111,0.399
			c-1.078,0-2.047-0.238-2.908-0.715c-0.861-0.476-1.537-1.151-2.026-2.026c-0.49-0.875-0.735-1.879-0.735-3.014
			c0-1.134,0.245-2.135,0.735-3.003c0.49-0.867,1.166-1.539,2.026-2.016c0.861-0.476,1.83-0.714,2.908-0.714
			c0.742,0,1.421,0.126,2.037,0.378s1.141,0.63,1.575,1.134V73.81H283.52z M279.299,86.861c0.504-0.287,0.903-0.696,1.197-1.229
			s0.441-1.148,0.441-1.849c0-0.699-0.147-1.315-0.441-1.848s-0.693-0.941-1.197-1.229s-1.071-0.431-1.701-0.431
			c-0.63,0-1.197,0.144-1.701,0.431s-0.903,0.696-1.197,1.229c-0.294,0.532-0.441,1.148-0.441,1.848c0,0.7,0.147,1.316,0.441,1.849
			c0.294,0.532,0.693,0.941,1.197,1.229s1.071,0.431,1.701,0.431C278.228,87.292,278.795,87.149,279.299,86.861z"
        />
        <path
          d="M295.038,79.238c0.875,0.791,1.312,1.984,1.312,3.58v6.573h-2.478v-1.365c-0.322,0.49-0.78,0.865-1.375,1.124
			s-1.312,0.389-2.152,0.389s-1.575-0.145-2.205-0.431c-0.63-0.287-1.117-0.687-1.459-1.197c-0.343-0.511-0.515-1.089-0.515-1.732
			c0-1.008,0.375-1.816,1.124-2.426c0.749-0.608,1.929-0.913,3.539-0.913h2.898v-0.168c0-0.784-0.234-1.387-0.704-1.807
			c-0.469-0.42-1.165-0.63-2.089-0.63c-0.63,0-1.25,0.099-1.858,0.294c-0.609,0.196-1.124,0.47-1.543,0.819l-1.029-1.911
			c0.588-0.448,1.295-0.791,2.121-1.029c0.826-0.237,1.701-0.356,2.625-0.356C292.899,78.052,294.163,78.447,295.038,79.238z
			 M292.644,87.176c0.511-0.301,0.872-0.731,1.082-1.291v-1.302h-2.709c-1.512,0-2.268,0.497-2.268,1.49
			c0,0.477,0.189,0.854,0.567,1.135c0.378,0.28,0.903,0.42,1.575,0.42C291.549,87.628,292.133,87.478,292.644,87.176z"
        />
        <path
          d="M300.509,89.182c-0.868-0.238-1.561-0.539-2.079-0.903l1.008-1.995c0.504,0.336,1.109,0.606,1.816,0.809
			c0.707,0.203,1.403,0.305,2.089,0.305c1.568,0,2.352-0.413,2.352-1.239c0-0.392-0.2-0.664-0.599-0.818s-1.04-0.301-1.921-0.441
			c-0.924-0.14-1.677-0.301-2.257-0.482c-0.581-0.183-1.085-0.501-1.512-0.956c-0.427-0.455-0.641-1.088-0.641-1.9
			c0-1.063,0.444-1.914,1.333-2.552c0.889-0.637,2.09-0.955,3.602-0.955c0.77,0,1.54,0.088,2.31,0.263s1.4,0.409,1.89,0.703
			l-1.008,1.995c-0.952-0.56-2.023-0.84-3.213-0.84c-0.77,0-1.354,0.115-1.753,0.347c-0.399,0.23-0.599,0.535-0.599,0.913
			c0,0.42,0.213,0.718,0.641,0.893c0.427,0.175,1.088,0.34,1.984,0.493c0.896,0.141,1.631,0.302,2.205,0.483
			c0.574,0.182,1.067,0.49,1.48,0.924c0.413,0.435,0.62,1.05,0.62,1.848c0,1.051-0.455,1.891-1.365,2.521s-2.149,0.945-3.717,0.945
			C302.265,89.539,301.376,89.42,300.509,89.182z"
        />
        <path
          d="M320.29,79.291c0.854,0.826,1.281,2.051,1.281,3.675v6.426h-2.625v-6.09c0-0.979-0.231-1.719-0.693-2.216
			c-0.462-0.497-1.121-0.745-1.974-0.745c-0.966,0-1.729,0.29-2.289,0.871c-0.56,0.581-0.84,1.418-0.84,2.51v5.67h-2.625V73.81
			h2.625v5.67c0.434-0.462,0.969-0.815,1.606-1.061c0.637-0.244,1.347-0.367,2.131-0.367
			C318.302,78.052,319.436,78.465,320.29,79.291z"
        />
        <path
          d="M334.056,78.766c0.86,0.477,1.536,1.148,2.026,2.016c0.489,0.868,0.734,1.869,0.734,3.003
			c0,1.135-0.245,2.139-0.734,3.014c-0.49,0.875-1.166,1.551-2.026,2.026c-0.861,0.477-1.838,0.715-2.93,0.715
			c-0.771,0-1.474-0.134-2.11-0.399c-0.638-0.266-1.173-0.665-1.606-1.197v1.449h-2.5V73.81h2.625v5.733
			c0.447-0.49,0.977-0.861,1.585-1.113c0.609-0.252,1.277-0.378,2.006-0.378C332.219,78.052,333.195,78.29,334.056,78.766z
			 M333.216,86.325c0.623-0.644,0.935-1.49,0.935-2.541c0-1.05-0.312-1.896-0.935-2.541c-0.623-0.644-1.417-0.966-2.383-0.966
			c-0.63,0-1.197,0.144-1.701,0.431s-0.903,0.696-1.197,1.229s-0.44,1.148-0.44,1.848c0,0.7,0.146,1.316,0.44,1.849
			s0.693,0.941,1.197,1.229s1.071,0.431,1.701,0.431C331.799,87.292,332.593,86.97,333.216,86.325z"
        />
        <path
          d="M341.29,88.804c-0.91-0.49-1.62-1.173-2.131-2.048c-0.512-0.875-0.767-1.865-0.767-2.972c0-1.105,0.255-2.093,0.767-2.961
			c0.511-0.867,1.221-1.547,2.131-2.037c0.91-0.489,1.933-0.734,3.066-0.734c1.147,0,2.177,0.245,3.087,0.734
			c0.91,0.49,1.62,1.17,2.132,2.037c0.511,0.868,0.767,1.855,0.767,2.961c0,1.106-0.256,2.097-0.767,2.972
			c-0.512,0.875-1.222,1.558-2.132,2.048s-1.939,0.735-3.087,0.735C343.222,89.539,342.2,89.294,341.29,88.804z M346.75,86.325
			c0.631-0.644,0.945-1.49,0.945-2.541c0-1.05-0.314-1.896-0.945-2.541c-0.63-0.644-1.428-0.966-2.394-0.966
			s-1.761,0.322-2.384,0.966c-0.623,0.645-0.935,1.491-0.935,2.541c0,1.051,0.312,1.897,0.935,2.541
			c0.623,0.645,1.418,0.967,2.384,0.967S346.12,86.97,346.75,86.325z"
        />
        <path
          d="M360.789,79.238c0.875,0.791,1.312,1.984,1.312,3.58v6.573h-2.478v-1.365c-0.322,0.49-0.78,0.865-1.376,1.124
			c-0.595,0.259-1.312,0.389-2.152,0.389s-1.575-0.145-2.205-0.431c-0.63-0.287-1.116-0.687-1.459-1.197
			c-0.344-0.511-0.515-1.089-0.515-1.732c0-1.008,0.374-1.816,1.123-2.426c0.749-0.608,1.929-0.913,3.539-0.913h2.897v-0.168
			c0-0.784-0.234-1.387-0.703-1.807s-1.165-0.63-2.09-0.63c-0.63,0-1.249,0.099-1.858,0.294c-0.608,0.196-1.123,0.47-1.543,0.819
			l-1.029-1.911c0.588-0.448,1.295-0.791,2.121-1.029c0.826-0.237,1.701-0.356,2.625-0.356
			C358.65,78.052,359.914,78.447,360.789,79.238z M358.395,87.176c0.511-0.301,0.871-0.731,1.081-1.291v-1.302h-2.709
			c-1.512,0-2.268,0.497-2.268,1.49c0,0.477,0.188,0.854,0.567,1.135c0.378,0.28,0.902,0.42,1.574,0.42
			C357.3,87.628,357.884,87.478,358.395,87.176z"
        />
        <path
          d="M371.95,78.052v2.499c-0.224-0.042-0.427-0.063-0.608-0.063c-1.022,0-1.82,0.298-2.395,0.893
			c-0.574,0.596-0.86,1.453-0.86,2.572v5.439h-2.625V78.178h2.499v1.638C368.717,78.64,370.047,78.052,371.95,78.052z"
        />
        <path
          d="M385.054,73.81v15.582h-2.52v-1.449c-0.435,0.532-0.97,0.932-1.606,1.197c-0.638,0.266-1.341,0.399-2.111,0.399
			c-1.078,0-2.047-0.238-2.908-0.715c-0.86-0.476-1.536-1.151-2.026-2.026s-0.735-1.879-0.735-3.014
			c0-1.134,0.245-2.135,0.735-3.003c0.49-0.867,1.166-1.539,2.026-2.016c0.861-0.476,1.83-0.714,2.908-0.714
			c0.742,0,1.421,0.126,2.037,0.378s1.142,0.63,1.575,1.134V73.81H385.054z M380.834,86.861c0.504-0.287,0.903-0.696,1.197-1.229
			s0.44-1.148,0.44-1.849c0-0.699-0.146-1.315-0.44-1.848s-0.693-0.941-1.197-1.229s-1.071-0.431-1.701-0.431
			s-1.197,0.144-1.701,0.431s-0.902,0.696-1.197,1.229c-0.294,0.532-0.44,1.148-0.44,1.848c0,0.7,0.146,1.316,0.44,1.849
			c0.295,0.532,0.693,0.941,1.197,1.229s1.071,0.431,1.701,0.431S380.33,87.149,380.834,86.861z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M49.272,277.474l-6.405,14.7h-2.688l-6.426-14.7h2.961l4.893,11.34l4.935-11.34H49.272z" />
        <path
          d="M60.234,287.407h-8.799c0.154,0.826,0.557,1.48,1.208,1.964c0.651,0.483,1.459,0.725,2.426,0.725
			c1.231,0,2.247-0.406,3.045-1.218l1.407,1.616c-0.504,0.603-1.141,1.058-1.911,1.365c-0.771,0.309-1.638,0.462-2.604,0.462
			c-1.232,0-2.317-0.244-3.255-0.734s-1.663-1.173-2.173-2.048c-0.511-0.875-0.767-1.865-0.767-2.972
			c0-1.092,0.249-2.075,0.746-2.95c0.497-0.875,1.187-1.558,2.068-2.048c0.882-0.489,1.876-0.734,2.982-0.734
			c1.092,0,2.068,0.241,2.929,0.724c0.861,0.483,1.533,1.163,2.016,2.037c0.483,0.875,0.725,1.887,0.725,3.035
			C60.276,286.812,60.261,287.071,60.234,287.407z M52.474,283.679c-0.581,0.497-0.935,1.159-1.061,1.985h6.363
			c-0.112-0.812-0.455-1.471-1.029-1.975s-1.288-0.756-2.142-0.756C53.765,282.934,53.055,283.183,52.474,283.679z"
        />
        <path
          d="M72.56,282.073c0.854,0.826,1.281,2.052,1.281,3.676v6.426h-2.625v-6.09c0-0.98-0.231-1.719-0.693-2.216
			c-0.462-0.497-1.121-0.745-1.974-0.745c-0.966,0-1.729,0.29-2.289,0.871c-0.56,0.581-0.84,1.417-0.84,2.51v5.67h-2.625v-15.582
			h2.625v5.67c0.434-0.462,0.969-0.815,1.606-1.061c0.637-0.245,1.347-0.367,2.131-0.367
			C70.573,280.835,71.706,281.248,72.56,282.073z"
        />
        <path
          d="M77.306,278.661c-0.322-0.301-0.483-0.676-0.483-1.124c0-0.447,0.161-0.822,0.483-1.123
			c0.322-0.301,0.721-0.451,1.197-0.451s0.875,0.144,1.197,0.43c0.322,0.287,0.483,0.648,0.483,1.082
			c0,0.462-0.158,0.851-0.473,1.165c-0.315,0.315-0.718,0.473-1.208,0.473C78.027,279.112,77.628,278.961,77.306,278.661z
			 M77.18,280.961h2.625v11.214H77.18V280.961z"
        />
        <path
          d="M85.265,291.586c-0.924-0.49-1.645-1.173-2.163-2.048c-0.518-0.875-0.777-1.865-0.777-2.972
			c0-1.105,0.259-2.093,0.777-2.961c0.518-0.868,1.235-1.547,2.152-2.037c0.917-0.489,1.963-0.734,3.14-0.734
			c1.105,0,2.075,0.224,2.908,0.672s1.459,1.092,1.879,1.932l-2.016,1.176c-0.322-0.518-0.725-0.906-1.208-1.165
			s-1.012-0.389-1.585-0.389c-0.98,0-1.792,0.318-2.436,0.955c-0.644,0.638-0.966,1.488-0.966,2.552
			c0,1.064,0.318,1.915,0.956,2.552s1.452,0.955,2.447,0.955c0.574,0,1.103-0.129,1.585-0.388c0.483-0.26,0.885-0.647,1.208-1.166
			l2.016,1.176c-0.434,0.84-1.067,1.488-1.9,1.942c-0.833,0.455-1.795,0.683-2.887,0.683
			C87.232,292.321,86.189,292.077,85.265,291.586z"
        />
        <path d="M95.345,276.592h2.625v15.582h-2.625V276.592z" />
        <path
          d="M111.914,287.407h-8.799c0.154,0.826,0.557,1.48,1.208,1.964c0.651,0.483,1.459,0.725,2.426,0.725
			c1.231,0,2.247-0.406,3.045-1.218l1.407,1.616c-0.504,0.603-1.141,1.058-1.911,1.365c-0.771,0.309-1.638,0.462-2.604,0.462
			c-1.232,0-2.317-0.244-3.255-0.734s-1.663-1.173-2.173-2.048c-0.511-0.875-0.767-1.865-0.767-2.972
			c0-1.092,0.249-2.075,0.746-2.95c0.497-0.875,1.187-1.558,2.068-2.048c0.882-0.489,1.876-0.734,2.982-0.734
			c1.092,0,2.068,0.241,2.929,0.724c0.861,0.483,1.533,1.163,2.016,2.037c0.483,0.875,0.725,1.887,0.725,3.035
			C111.956,286.812,111.942,287.071,111.914,287.407z M104.155,283.679c-0.581,0.497-0.935,1.159-1.061,1.985h6.363
			c-0.112-0.812-0.455-1.471-1.029-1.975s-1.288-0.756-2.142-0.756C105.446,282.934,104.736,283.183,104.155,283.679z"
        />
        <path
          d="M42.069,303.835v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.298-2.394,0.893
			c-0.574,0.596-0.861,1.453-0.861,2.572v5.439H35.58v-11.214h2.499v1.638C38.835,304.422,40.165,303.835,42.069,303.835z"
        />
        <path
          d="M54.69,310.408H45.89c0.154,0.826,0.557,1.48,1.208,1.963c0.651,0.483,1.459,0.725,2.426,0.725
			c1.231,0,2.247-0.406,3.045-1.218l1.407,1.617c-0.504,0.602-1.141,1.057-1.911,1.364c-0.771,0.309-1.638,0.463-2.604,0.463
			c-1.232,0-2.317-0.245-3.255-0.735s-1.663-1.173-2.173-2.048c-0.511-0.875-0.767-1.865-0.767-2.972
			c0-1.092,0.249-2.075,0.746-2.95c0.497-0.875,1.187-1.558,2.068-2.048c0.882-0.489,1.876-0.734,2.982-0.734
			c1.092,0,2.068,0.241,2.929,0.725c0.861,0.482,1.533,1.162,2.016,2.037s0.725,1.887,0.725,3.034
			C54.732,309.812,54.718,310.072,54.69,310.408z M46.93,306.68c-0.581,0.497-0.935,1.158-1.061,1.984h6.363
			c-0.112-0.812-0.455-1.471-1.029-1.975s-1.288-0.756-2.142-0.756C48.221,305.934,47.511,306.183,46.93,306.68z"
        />
        <path
          d="M68.382,303.961v9.513c0,3.948-2.016,5.922-6.048,5.922c-1.079,0-2.1-0.136-3.066-0.409
			c-0.966-0.273-1.764-0.669-2.394-1.187l1.176-1.974c0.49,0.405,1.109,0.731,1.858,0.977c0.749,0.244,1.508,0.367,2.279,0.367
			c1.231,0,2.135-0.28,2.709-0.84c0.574-0.561,0.861-1.414,0.861-2.562v-0.588c-0.448,0.49-0.994,0.861-1.638,1.113
			s-1.351,0.378-2.121,0.378c-1.064,0-2.026-0.228-2.887-0.683s-1.541-1.096-2.037-1.922c-0.497-0.825-0.746-1.771-0.746-2.835
			c0-1.063,0.249-2.005,0.746-2.824c0.497-0.819,1.176-1.452,2.037-1.9s1.823-0.672,2.887-0.672c0.812,0,1.551,0.133,2.216,0.398
			c0.665,0.267,1.221,0.673,1.669,1.219v-1.491H68.382z M64.843,311.552c0.637-0.596,0.956-1.369,0.956-2.321
			c0-0.938-0.319-1.7-0.956-2.289c-0.637-0.588-1.453-0.882-2.446-0.882c-1.008,0-1.831,0.294-2.468,0.882
			c-0.637,0.589-0.956,1.352-0.956,2.289c0,0.952,0.318,1.726,0.956,2.321c0.637,0.595,1.459,0.892,2.468,0.892
			C63.39,312.444,64.206,312.147,64.843,311.552z"
        />
        <path
          d="M71.951,301.661c-0.322-0.301-0.483-0.675-0.483-1.123s0.161-0.822,0.483-1.124c0.322-0.301,0.721-0.451,1.197-0.451
			s0.875,0.144,1.197,0.431c0.322,0.287,0.483,0.647,0.483,1.081c0,0.462-0.158,0.851-0.473,1.166
			c-0.315,0.314-0.718,0.473-1.208,0.473C72.672,302.113,72.273,301.962,71.951,301.661z M71.825,303.961h2.625v11.214h-2.625
			V303.961z"
        />
        <path
          d="M78.692,314.964c-0.868-0.238-1.561-0.539-2.079-0.903l1.008-1.995c0.504,0.336,1.109,0.606,1.816,0.809
			c0.707,0.203,1.403,0.305,2.089,0.305c1.568,0,2.352-0.413,2.352-1.239c0-0.392-0.2-0.664-0.599-0.818s-1.04-0.301-1.921-0.441
			c-0.924-0.14-1.677-0.301-2.257-0.482c-0.581-0.183-1.085-0.501-1.512-0.956c-0.427-0.455-0.641-1.088-0.641-1.9
			c0-1.063,0.444-1.914,1.333-2.552c0.889-0.637,2.09-0.955,3.602-0.955c0.77,0,1.54,0.088,2.31,0.263s1.4,0.409,1.89,0.703
			l-1.008,1.995c-0.952-0.56-2.023-0.84-3.213-0.84c-0.77,0-1.354,0.115-1.753,0.347c-0.399,0.23-0.599,0.535-0.599,0.913
			c0,0.42,0.213,0.718,0.641,0.893c0.427,0.175,1.088,0.34,1.984,0.493c0.896,0.141,1.631,0.302,2.205,0.483
			c0.574,0.182,1.067,0.49,1.48,0.924c0.413,0.435,0.62,1.05,0.62,1.848c0,1.051-0.455,1.891-1.365,2.521s-2.149,0.945-3.717,0.945
			C80.449,315.322,79.56,315.203,78.692,314.964z"
        />
        <path
          d="M95.45,314.565c-0.308,0.252-0.683,0.441-1.124,0.567s-0.906,0.189-1.396,0.189c-1.232,0-2.184-0.322-2.856-0.967
			c-0.672-0.644-1.008-1.582-1.008-2.813v-5.397h-1.848v-2.1h1.848v-2.562h2.625v2.562h3.003v2.1h-3.003v5.334
			c0,0.546,0.133,0.963,0.399,1.25c0.266,0.287,0.651,0.431,1.155,0.431c0.588,0,1.078-0.154,1.47-0.462L95.45,314.565z"
        />
        <path
          d="M104.102,303.835v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.298-2.394,0.893
			c-0.574,0.596-0.861,1.453-0.861,2.572v5.439h-2.625v-11.214h2.499v1.638C100.868,304.422,102.198,303.835,104.102,303.835z"
        />
        <path
          d="M114.34,305.021c0.875,0.791,1.312,1.984,1.312,3.58v6.573h-2.478v-1.365c-0.322,0.49-0.78,0.865-1.375,1.124
			s-1.312,0.389-2.152,0.389s-1.575-0.145-2.205-0.431c-0.63-0.287-1.117-0.687-1.459-1.197c-0.343-0.511-0.515-1.089-0.515-1.732
			c0-1.008,0.375-1.816,1.124-2.426c0.749-0.608,1.929-0.913,3.539-0.913h2.898v-0.168c0-0.784-0.234-1.387-0.704-1.807
			c-0.469-0.42-1.165-0.63-2.089-0.63c-0.63,0-1.25,0.099-1.858,0.294c-0.609,0.196-1.124,0.47-1.543,0.819l-1.029-1.911
			c0.588-0.448,1.295-0.791,2.121-1.029c0.826-0.237,1.701-0.356,2.625-0.356C112.201,303.835,113.465,304.23,114.34,305.021z
			 M111.946,312.959c0.511-0.301,0.872-0.731,1.082-1.291v-1.302h-2.709c-1.512,0-2.268,0.497-2.268,1.49
			c0,0.477,0.189,0.854,0.567,1.135c0.378,0.28,0.903,0.42,1.575,0.42C110.85,313.411,111.434,313.26,111.946,312.959z"
        />
        <path
          d="M125.753,314.565c-0.308,0.252-0.683,0.441-1.124,0.567s-0.906,0.189-1.396,0.189c-1.232,0-2.184-0.322-2.856-0.967
			c-0.672-0.644-1.008-1.582-1.008-2.813v-5.397h-1.848v-2.1h1.848v-2.562h2.625v2.562h3.003v2.1h-3.003v5.334
			c0,0.546,0.133,0.963,0.399,1.25c0.266,0.287,0.651,0.431,1.155,0.431c0.588,0,1.078-0.154,1.47-0.462L125.753,314.565z"
        />
        <path
          d="M128.042,301.661c-0.322-0.301-0.483-0.675-0.483-1.123s0.161-0.822,0.483-1.124c0.322-0.301,0.721-0.451,1.197-0.451
			s0.875,0.144,1.197,0.431c0.322,0.287,0.483,0.647,0.483,1.081c0,0.462-0.158,0.851-0.473,1.166
			c-0.315,0.314-0.718,0.473-1.208,0.473C128.762,302.113,128.364,301.962,128.042,301.661z M127.916,303.961h2.625v11.214h-2.625
			V303.961z"
        />
        <path
          d="M135.958,314.586c-0.91-0.49-1.621-1.173-2.131-2.048c-0.511-0.875-0.767-1.865-0.767-2.972
			c0-1.105,0.255-2.093,0.767-2.961c0.511-0.867,1.221-1.547,2.131-2.037c0.91-0.489,1.932-0.734,3.066-0.734
			c1.147,0,2.177,0.245,3.087,0.734c0.91,0.49,1.62,1.17,2.131,2.037c0.511,0.868,0.767,1.855,0.767,2.961
			c0,1.106-0.256,2.097-0.767,2.972c-0.511,0.875-1.222,1.558-2.131,2.048c-0.91,0.49-1.939,0.735-3.087,0.735
			C137.89,315.322,136.868,315.077,135.958,314.586z M141.418,312.108c0.63-0.644,0.945-1.49,0.945-2.541
			c0-1.05-0.315-1.896-0.945-2.541c-0.63-0.644-1.428-0.966-2.394-0.966c-0.966,0-1.761,0.322-2.384,0.966
			c-0.623,0.645-0.935,1.491-0.935,2.541c0,1.051,0.312,1.897,0.935,2.541c0.623,0.645,1.417,0.967,2.384,0.967
			C139.99,313.075,140.788,312.753,141.418,312.108z"
        />
        <path
          d="M157.294,305.074c0.854,0.826,1.281,2.051,1.281,3.675v6.426h-2.625v-6.09c0-0.979-0.231-1.719-0.693-2.216
			c-0.462-0.497-1.121-0.745-1.974-0.745c-0.966,0-1.729,0.29-2.289,0.871c-0.56,0.581-0.84,1.418-0.84,2.51v5.67h-2.625v-11.214
			h2.499v1.449c0.434-0.519,0.979-0.91,1.638-1.177c0.658-0.266,1.4-0.398,2.226-0.398
			C155.306,303.835,156.44,304.248,157.294,305.074z"
        />
      </g>
    </g>
    <g>
      <path d="M29.165,3.984h2.73v14.7h-2.73V3.984z" />
      <path
        d="M45.376,8.583c0.854,0.826,1.281,2.051,1.281,3.675v6.426h-2.625v-6.09c0-0.98-0.231-1.719-0.693-2.216
		c-0.462-0.497-1.121-0.745-1.974-0.745c-0.966,0-1.729,0.291-2.289,0.871c-0.56,0.581-0.84,1.417-0.84,2.51v5.67h-2.625V7.47h2.499
		v1.449c0.434-0.518,0.979-0.91,1.638-1.176c0.658-0.266,1.4-0.399,2.226-0.399C43.388,7.344,44.522,7.757,45.376,8.583z"
      />
      <path
        d="M50.794,18.474c-0.868-0.238-1.561-0.539-2.079-0.903l1.008-1.995c0.504,0.336,1.109,0.605,1.816,0.809
		c0.707,0.203,1.403,0.304,2.089,0.304c1.568,0,2.352-0.413,2.352-1.239c0-0.392-0.2-0.665-0.599-0.819
		c-0.399-0.154-1.04-0.301-1.921-0.441c-0.924-0.14-1.677-0.301-2.257-0.483c-0.581-0.182-1.085-0.5-1.512-0.956
		c-0.427-0.455-0.641-1.088-0.641-1.9c0-1.064,0.444-1.914,1.333-2.551s2.09-0.956,3.602-0.956c0.77,0,1.54,0.087,2.31,0.262
		c0.77,0.175,1.4,0.41,1.89,0.704l-1.008,1.995c-0.952-0.56-2.023-0.84-3.213-0.84c-0.77,0-1.354,0.116-1.753,0.347
		s-0.599,0.536-0.599,0.914c0,0.42,0.213,0.718,0.641,0.893c0.427,0.175,1.088,0.339,1.984,0.493
		c0.896,0.14,1.631,0.301,2.205,0.483c0.574,0.182,1.067,0.49,1.48,0.924c0.413,0.434,0.62,1.05,0.62,1.848
		c0,1.05-0.455,1.89-1.365,2.52c-0.91,0.63-2.149,0.945-3.717,0.945C52.551,18.831,51.662,18.712,50.794,18.474z"
      />
      <path
        d="M60.937,5.17c-0.322-0.301-0.483-0.675-0.483-1.124c0-0.448,0.161-0.822,0.483-1.124c0.322-0.301,0.721-0.451,1.197-0.451
		s0.875,0.144,1.197,0.43c0.322,0.287,0.483,0.648,0.483,1.082c0,0.462-0.158,0.851-0.473,1.166s-0.718,0.473-1.208,0.473
		C61.658,5.622,61.259,5.472,60.937,5.17z M60.811,7.47h2.625v11.214h-2.625V7.47z"
      />
      <path
        d="M77.863,3.102v15.582h-2.52v-1.449c-0.434,0.532-0.97,0.932-1.606,1.197c-0.637,0.266-1.341,0.399-2.111,0.399
		c-1.078,0-2.047-0.238-2.908-0.714s-1.537-1.151-2.026-2.026c-0.49-0.875-0.735-1.88-0.735-3.014c0-1.134,0.245-2.135,0.735-3.003
		c0.49-0.868,1.166-1.54,2.026-2.016c0.861-0.476,1.83-0.714,2.908-0.714c0.742,0,1.421,0.126,2.037,0.378s1.141,0.63,1.575,1.134
		V3.102H77.863z M73.642,16.154c0.504-0.287,0.903-0.696,1.197-1.229s0.441-1.148,0.441-1.848s-0.147-1.316-0.441-1.848
		c-0.294-0.532-0.693-0.941-1.197-1.229c-0.504-0.287-1.071-0.43-1.701-0.43c-0.63,0-1.197,0.144-1.701,0.43
		c-0.504,0.287-0.903,0.697-1.197,1.229c-0.294,0.532-0.441,1.148-0.441,1.848s0.147,1.316,0.441,1.848
		c0.294,0.532,0.693,0.941,1.197,1.229c0.504,0.287,1.071,0.43,1.701,0.43C72.571,16.584,73.138,16.441,73.642,16.154z"
      />
      <path
        d="M91.807,13.917h-8.799c0.154,0.826,0.557,1.48,1.208,1.963c0.651,0.483,1.459,0.725,2.426,0.725
		c1.231,0,2.247-0.406,3.045-1.218l1.407,1.617c-0.504,0.602-1.141,1.058-1.911,1.365c-0.771,0.308-1.638,0.462-2.604,0.462
		c-1.232,0-2.317-0.245-3.255-0.735s-1.663-1.172-2.173-2.048c-0.511-0.875-0.767-1.865-0.767-2.971
		c0-1.092,0.249-2.076,0.746-2.951c0.497-0.875,1.187-1.557,2.068-2.047c0.882-0.49,1.876-0.735,2.982-0.735
		c1.092,0,2.068,0.241,2.929,0.724c0.861,0.483,1.533,1.163,2.016,2.037c0.483,0.875,0.725,1.887,0.725,3.035
		C91.849,13.322,91.835,13.581,91.807,13.917z M84.047,10.19c-0.581,0.497-0.935,1.159-1.061,1.985h6.363
		c-0.112-0.812-0.455-1.47-1.029-1.974s-1.288-0.756-2.142-0.756C85.339,9.444,84.628,9.693,84.047,10.19z"
      />
      <path
        d="M111.148,3.102v15.582h-2.52v-1.449c-0.434,0.532-0.97,0.932-1.606,1.197c-0.637,0.266-1.341,0.399-2.111,0.399
		c-1.078,0-2.047-0.238-2.908-0.714s-1.537-1.151-2.026-2.026c-0.49-0.875-0.735-1.88-0.735-3.014c0-1.134,0.245-2.135,0.735-3.003
		c0.49-0.868,1.166-1.54,2.026-2.016c0.861-0.476,1.83-0.714,2.908-0.714c0.742,0,1.421,0.126,2.037,0.378s1.141,0.63,1.575,1.134
		V3.102H111.148z M106.927,16.154c0.504-0.287,0.903-0.696,1.197-1.229s0.441-1.148,0.441-1.848s-0.147-1.316-0.441-1.848
		c-0.294-0.532-0.693-0.941-1.197-1.229c-0.504-0.287-1.071-0.43-1.701-0.43c-0.63,0-1.197,0.144-1.701,0.43
		c-0.504,0.287-0.903,0.697-1.197,1.229c-0.294,0.532-0.441,1.148-0.441,1.848s0.147,1.316,0.441,1.848
		c0.294,0.532,0.693,0.941,1.197,1.229c0.504,0.287,1.071,0.43,1.701,0.43C105.856,16.584,106.423,16.441,106.927,16.154z"
      />
      <path
        d="M121.08,7.344v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.297-2.394,0.892
		c-0.574,0.595-0.861,1.453-0.861,2.573v5.439h-2.625V7.47h2.499v1.638C117.846,7.932,119.177,7.344,121.08,7.344z"
      />
      <path
        d="M123.433,5.17c-0.322-0.301-0.483-0.675-0.483-1.124c0-0.448,0.161-0.822,0.483-1.124c0.322-0.301,0.721-0.451,1.197-0.451
		s0.875,0.144,1.197,0.43c0.322,0.287,0.483,0.648,0.483,1.082c0,0.462-0.158,0.851-0.473,1.166s-0.718,0.473-1.208,0.473
		C124.154,5.622,123.755,5.472,123.433,5.17z M123.307,7.47h2.625v11.214h-2.625V7.47z"
      />
      <path d="M139.876,7.47l-4.809,11.214h-2.709L127.549,7.47h2.73l3.486,8.316l3.591-8.316H139.876z" />
      <path
        d="M151.698,13.917h-8.799c0.154,0.826,0.557,1.48,1.208,1.963c0.651,0.483,1.459,0.725,2.426,0.725
		c1.231,0,2.247-0.406,3.045-1.218l1.407,1.617c-0.504,0.602-1.141,1.058-1.911,1.365c-0.771,0.308-1.638,0.462-2.604,0.462
		c-1.232,0-2.317-0.245-3.255-0.735s-1.663-1.172-2.173-2.048c-0.511-0.875-0.767-1.865-0.767-2.971
		c0-1.092,0.249-2.076,0.746-2.951c0.497-0.875,1.187-1.557,2.068-2.047c0.882-0.49,1.876-0.735,2.982-0.735
		c1.092,0,2.068,0.241,2.929,0.724c0.861,0.483,1.533,1.163,2.016,2.037c0.483,0.875,0.725,1.887,0.725,3.035
		C151.74,13.322,151.726,13.581,151.698,13.917z M143.938,10.19c-0.581,0.497-0.935,1.159-1.061,1.985h6.363
		c-0.112-0.812-0.455-1.47-1.029-1.974s-1.288-0.756-2.142-0.756C145.23,9.444,144.519,9.693,143.938,10.19z"
      />
      <path
        d="M160.749,7.344v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.297-2.394,0.892
		c-0.574,0.595-0.861,1.453-0.861,2.573v5.439h-2.625V7.47h2.499v1.638C157.515,7.932,158.845,7.344,160.749,7.344z"
      />
      <path
        d="M165.893,3.438c0.322,0.322,0.483,0.735,0.483,1.239c0,0.252-0.032,0.497-0.095,0.735
		c-0.063,0.238-0.186,0.595-0.368,1.071l-1.092,2.982h-1.701l0.84-3.234c-0.308-0.112-0.55-0.304-0.725-0.577
		c-0.175-0.273-0.263-0.599-0.263-0.977c0-0.504,0.161-0.917,0.483-1.239c0.322-0.322,0.728-0.483,1.218-0.483
		C165.165,2.955,165.572,3.116,165.893,3.438z"
      />
      <path
        d="M169.38,18.474c-0.868-0.238-1.561-0.539-2.079-0.903l1.008-1.995c0.504,0.336,1.109,0.605,1.816,0.809
		c0.707,0.203,1.403,0.304,2.089,0.304c1.568,0,2.352-0.413,2.352-1.239c0-0.392-0.2-0.665-0.599-0.819
		c-0.399-0.154-1.04-0.301-1.921-0.441c-0.924-0.14-1.677-0.301-2.257-0.483c-0.581-0.182-1.085-0.5-1.512-0.956
		c-0.427-0.455-0.641-1.088-0.641-1.9c0-1.064,0.444-1.914,1.333-2.551s2.09-0.956,3.602-0.956c0.77,0,1.54,0.087,2.31,0.262
		c0.77,0.175,1.4,0.41,1.89,0.704l-1.008,1.995c-0.952-0.56-2.023-0.84-3.213-0.84c-0.77,0-1.354,0.116-1.753,0.347
		s-0.599,0.536-0.599,0.914c0,0.42,0.213,0.718,0.641,0.893c0.427,0.175,1.088,0.339,1.984,0.493
		c0.896,0.14,1.631,0.301,2.205,0.483c0.574,0.182,1.067,0.49,1.48,0.924c0.413,0.434,0.62,1.05,0.62,1.848
		c0,1.05-0.455,1.89-1.365,2.52c-0.91,0.63-2.149,0.945-3.717,0.945C171.136,18.831,170.247,18.712,169.38,18.474z"
      />
      <path
        d="M39.896,26.102v15.582h-2.52v-1.449c-0.434,0.532-0.97,0.932-1.606,1.197c-0.637,0.266-1.341,0.399-2.111,0.399
		c-1.078,0-2.047-0.238-2.908-0.715c-0.861-0.476-1.537-1.151-2.026-2.026c-0.49-0.875-0.735-1.879-0.735-3.014
		c0-1.134,0.245-2.135,0.735-3.003c0.49-0.867,1.166-1.539,2.026-2.016c0.861-0.476,1.83-0.714,2.908-0.714
		c0.742,0,1.421,0.126,2.037,0.378s1.141,0.63,1.575,1.134v-5.754H39.896z M35.675,39.154c0.504-0.287,0.903-0.696,1.197-1.229
		s0.441-1.148,0.441-1.849c0-0.699-0.147-1.315-0.441-1.848s-0.693-0.941-1.197-1.229s-1.071-0.431-1.701-0.431
		c-0.63,0-1.197,0.144-1.701,0.431s-0.903,0.696-1.197,1.229c-0.294,0.532-0.441,1.148-0.441,1.848c0,0.7,0.147,1.316,0.441,1.849
		c0.294,0.532,0.693,0.941,1.197,1.229s1.071,0.431,1.701,0.431C34.604,39.585,35.171,39.441,35.675,39.154z"
      />
      <path
        d="M45.313,41.096c-0.91-0.49-1.621-1.173-2.131-2.048c-0.511-0.875-0.767-1.865-0.767-2.972c0-1.105,0.255-2.093,0.767-2.961
		c0.511-0.867,1.221-1.547,2.131-2.037c0.91-0.489,1.932-0.734,3.066-0.734c1.147,0,2.177,0.245,3.087,0.734
		c0.91,0.49,1.62,1.17,2.131,2.037c0.511,0.868,0.767,1.855,0.767,2.961c0,1.106-0.256,2.097-0.767,2.972
		c-0.511,0.875-1.222,1.558-2.131,2.048c-0.91,0.49-1.939,0.735-3.087,0.735C47.245,41.832,46.223,41.586,45.313,41.096z
		 M50.773,38.618c0.63-0.644,0.945-1.49,0.945-2.541c0-1.05-0.315-1.896-0.945-2.541c-0.63-0.644-1.428-0.966-2.394-0.966
		c-0.966,0-1.761,0.322-2.384,0.966c-0.623,0.645-0.935,1.491-0.935,2.541c0,1.051,0.312,1.897,0.935,2.541
		c0.623,0.645,1.417,0.967,2.384,0.967C49.345,39.585,50.143,39.262,50.773,38.618z"
      />
      <path
        d="M58.858,41.096c-0.91-0.49-1.621-1.173-2.131-2.048c-0.511-0.875-0.767-1.865-0.767-2.972c0-1.105,0.255-2.093,0.767-2.961
		c0.511-0.867,1.221-1.547,2.131-2.037c0.91-0.489,1.932-0.734,3.066-0.734c1.147,0,2.177,0.245,3.087,0.734
		c0.91,0.49,1.62,1.17,2.131,2.037c0.511,0.868,0.767,1.855,0.767,2.961c0,1.106-0.256,2.097-0.767,2.972
		c-0.511,0.875-1.222,1.558-2.131,2.048c-0.91,0.49-1.939,0.735-3.087,0.735C60.79,41.832,59.768,41.586,58.858,41.096z
		 M64.318,38.618c0.63-0.644,0.945-1.49,0.945-2.541c0-1.05-0.315-1.896-0.945-2.541c-0.63-0.644-1.428-0.966-2.394-0.966
		c-0.966,0-1.761,0.322-2.384,0.966c-0.623,0.645-0.935,1.491-0.935,2.541c0,1.051,0.312,1.897,0.935,2.541
		c0.623,0.645,1.417,0.967,2.384,0.967C62.89,39.585,63.688,39.262,64.318,38.618z"
      />
      <path
        d="M76.918,30.344v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.298-2.394,0.893
		c-0.574,0.596-0.861,1.453-0.861,2.572v5.439h-2.625V30.47h2.499v1.638C73.684,30.932,75.014,30.344,76.918,30.344z"
      />
      <path
        d="M75.574,45.254l0.756-1.953c0.392,0.294,0.903,0.44,1.533,0.44c0.49,0,0.864-0.15,1.124-0.451
		c0.259-0.301,0.389-0.745,0.389-1.333V30.47H82v11.424c0,1.246-0.343,2.226-1.029,2.94c-0.686,0.714-1.645,1.07-2.877,1.07
		C76.989,45.905,76.148,45.688,75.574,45.254z M79.48,28.17c-0.322-0.301-0.483-0.675-0.483-1.123s0.161-0.822,0.483-1.124
		c0.322-0.301,0.721-0.451,1.197-0.451s0.875,0.144,1.197,0.431c0.322,0.287,0.483,0.647,0.483,1.081
		c0,0.462-0.158,0.851-0.473,1.166c-0.315,0.314-0.718,0.473-1.208,0.473C80.201,28.623,79.802,28.472,79.48,28.17z"
      />
      <path
        d="M93.518,31.531c0.875,0.791,1.312,1.984,1.312,3.58v6.573h-2.478v-1.365c-0.322,0.49-0.78,0.865-1.375,1.124
		s-1.312,0.389-2.152,0.389s-1.575-0.145-2.205-0.431c-0.63-0.287-1.117-0.687-1.459-1.197c-0.343-0.511-0.515-1.089-0.515-1.732
		c0-1.008,0.375-1.816,1.124-2.426c0.749-0.608,1.929-0.913,3.539-0.913h2.898v-0.168c0-0.784-0.234-1.387-0.704-1.807
		c-0.469-0.42-1.165-0.63-2.089-0.63c-0.63,0-1.25,0.099-1.858,0.294c-0.609,0.196-1.124,0.47-1.543,0.819l-1.029-1.911
		c0.588-0.448,1.295-0.791,2.121-1.029c0.826-0.237,1.701-0.356,2.625-0.356C91.38,30.344,92.643,30.74,93.518,31.531z
		 M91.124,39.468c0.511-0.301,0.872-0.731,1.082-1.291v-1.302h-2.709c-1.512,0-2.268,0.497-2.268,1.49
		c0,0.477,0.189,0.854,0.567,1.135c0.378,0.28,0.903,0.42,1.575,0.42C90.029,39.92,90.613,39.77,91.124,39.468z"
      />
      <path
        d="M115.705,31.573c0.826,0.818,1.239,2.047,1.239,3.686v6.426h-2.625v-6.09c0-0.979-0.217-1.719-0.651-2.216
		c-0.435-0.497-1.058-0.745-1.869-0.745c-0.882,0-1.589,0.29-2.121,0.871c-0.532,0.581-0.798,1.411-0.798,2.488v5.691h-2.625v-6.09
		c0-0.979-0.217-1.719-0.651-2.216s-1.057-0.745-1.869-0.745c-0.896,0-1.606,0.287-2.132,0.86c-0.525,0.574-0.787,1.407-0.787,2.499
		v5.691h-2.625V30.47h2.499v1.428c0.42-0.504,0.945-0.889,1.575-1.155c0.63-0.266,1.33-0.398,2.1-0.398
		c0.84,0,1.585,0.157,2.236,0.473c0.651,0.314,1.166,0.78,1.543,1.396c0.462-0.588,1.057-1.047,1.785-1.376
		c0.728-0.328,1.533-0.493,2.415-0.493C113.759,30.344,114.879,30.753,115.705,31.573z"
      />
      <path
        d="M129.449,31.058c0.861,0.477,1.536,1.148,2.026,2.016c0.49,0.868,0.735,1.869,0.735,3.003c0,1.135-0.245,2.139-0.735,3.014
		c-0.49,0.875-1.166,1.551-2.026,2.026c-0.861,0.477-1.838,0.715-2.93,0.715c-0.77,0-1.474-0.134-2.11-0.399
		c-0.637-0.266-1.173-0.665-1.606-1.197v1.449h-2.499V26.102h2.625v5.733c0.448-0.49,0.977-0.861,1.585-1.113
		s1.277-0.378,2.005-0.378C127.612,30.344,128.588,30.583,129.449,31.058z M128.609,38.618c0.623-0.644,0.935-1.49,0.935-2.541
		c0-1.05-0.312-1.896-0.935-2.541c-0.623-0.644-1.417-0.966-2.383-0.966c-0.63,0-1.197,0.144-1.701,0.431s-0.903,0.696-1.197,1.229
		s-0.441,1.148-0.441,1.848c0,0.7,0.147,1.316,0.441,1.849s0.693,0.941,1.197,1.229s1.071,0.431,1.701,0.431
		C127.192,39.585,127.986,39.262,128.609,38.618z"
      />
    </g>
    <polyline
      fill="none"
      stroke="#F3BC2A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke-miterlimit="10"
      points="
	62.059,133.998 51.059,120.598 38.259,133.398 "
    />
    <path fill="#EBEBEB" d="M60.059,140.598c0,0,0-11.2,1-14.8c0,0,8.2,5.8,8.2,11C69.259,141.998,60.059,140.598,60.059,140.598z" />
    <g>
      <rect x="30.949" y="331.997" fill="#DCDCDC" width="173.709" height="128.234" />
      <rect x="39.061" y="340.422" fill="#FFFFFF" width="157.579" height="111.384" />
      <circle fill="#F2F2F2" cx="118.792" cy="418.064" r="24" />
      <g>
        <path
          fill="#C0C0C0"
          d="M53.566,345.33c1.027,0,1.793,0.177,2.297,0.529c0.503,0.354,0.841,0.826,1.013,1.42
			c0.172,0.593,0.216,1.276,0.133,2.05c-0.084,0.772-0.206,1.578-0.366,2.417c-0.16,0.839-0.345,1.644-0.555,2.417
			c-0.211,0.772-0.515,1.455-0.914,2.048c-0.398,0.593-0.917,1.067-1.554,1.42c-0.638,0.354-1.471,0.531-2.499,0.531h-5.137
			l2.445-12.831H53.566z M50.686,355.753c0.343,0,0.624-0.044,0.844-0.135c0.22-0.09,0.411-0.278,0.574-0.566
			c0.162-0.287,0.31-0.694,0.442-1.222c0.132-0.527,0.28-1.222,0.445-2.084c0.165-0.863,0.28-1.557,0.35-2.085
			c0.069-0.527,0.076-0.935,0.024-1.222c-0.053-0.287-0.172-0.476-0.358-0.566c-0.186-0.09-0.45-0.135-0.793-0.135h-0.704
			l-1.527,8.016H50.686z"
        />
        <path
          fill="#C0C0C0"
          d="M64.278,345.33l-0.022,7.602h0.038l2.876-7.602h5.061l-2.445,12.831h-3.311l1.822-9.56h-0.038l-3.706,9.56
			h-2.55l-0.061-9.56h-0.038l-1.822,9.56h-3.31l2.445-12.831H64.278z"
        />
        <path fill="#C0C0C0" d="M76.435,345.33l-0.415,9.667h0.038l3.269-9.667h3.767l-5.375,12.831h-4.567l-0.428-12.831H76.435z" />
      </g>
      <rect x="63.859" y="365.597" fill="#C0C0C0" width="107.733" height="4.267" />
      <rect x="48.403" y="373.064" fill="#C0C0C0" width="138.476" height="4.184" />
      <rect x="63.859" y="386.397" fill="#C0C0C0" width="107.733" height="4.267" />
      <rect x="49.459" y="424.764" fill="#C0C0C0" width="35.26" height="4.267" />
      <rect x="102.466" y="424.764" fill="#C0C0C0" width="35.26" height="4.267" />
      <rect x="49.459" y="432.764" fill="#C0C0C0" width="24.633" height="4.267" />
      <rect x="102.749" y="432.764" fill="#C0C0C0" width="24.633" height="4.267" />
      <rect x="49.459" y="401.764" fill="#C0C0C0" width="39.098" height="4.267" />
      <rect x="49.459" y="409.764" fill="#C0C0C0" width="29.476" height="4.267" />
      <rect x="102.182" y="401.764" fill="#C0C0C0" width="34.275" height="4.267" />
      <rect x="153.583" y="401.764" fill="#C0C0C0" width="34.275" height="4.267" />
      <rect x="102.182" y="409.764" fill="#C0C0C0" width="25.238" height="4.267" />
      <rect x="153.583" y="409.764" fill="#C0C0C0" width="25.238" height="4.267" />
      <g>
        <rect x="48.459" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="53.059" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="57.659" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="65.059" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="69.658" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="62.259" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="74.058" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="76.658" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="79.658" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="84.258" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="88.858" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="96.258" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="100.858" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="93.458" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="112.858" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="117.458" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="122.058" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="129.458" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="126.658" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="105.258" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="107.858" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="110.458" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="133.758" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="138.358" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="142.958" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="150.358" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="154.958" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="147.558" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="159.358" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="161.958" y="340.197" fill="#505050" width="1.377" height="7.6" />
        <rect x="164.958" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="169.558" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="174.158" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="181.558" y="340.197" fill="#505050" width="3" height="7.6" />
        <rect x="178.758" y="340.197" fill="#505050" width="1.377" height="7.6" />
      </g>

      <ellipse fill="none" stroke="#F3BC2A" strokeWidth="3" strokeLinejoin="round" stroke-miterlimit="10" cx="69.058" cy="404.419" rx="26" ry="8.769" />
    </g>
    <g>
      <path
        fill="#FFFFFF"
        d="M297.433,511.997H173c-6.299,0-11.406-5.107-11.406-11.406v-67.965c0-6.299,5.107-11.406,11.406-11.406
		h124.433c6.299,0,11.406,5.107,11.406,11.406v67.965C308.839,506.89,303.733,511.997,297.433,511.997z"
      />
      <path
        fill="#EBEBEB"
        d="M294.885,506.775H173.364c-3.84,0-6.953-3.113-6.953-6.953V432.96c0-3.84,3.113-6.953,6.953-6.953h121.521
		c3.84,0,6.953,3.113,6.953,6.953v66.862C301.838,503.662,298.725,506.775,294.885,506.775z"
      />
      <rect x="199.644" y="436.269" fill="#C0C0C0" width="91.908" height="4.077" />
      <rect x="199.644" y="444.805" fill="#C0C0C0" width="70.903" height="4.077" />
      <rect x="175.647" y="483.801" fill="#C0C0C0" width="36.012" height="4.865" />
      <rect x="175.647" y="492.723" fill="#C0C0C0" width="28.22" height="4.824" />
      <rect x="252.56" y="483.801" fill="#C0C0C0" width="36.012" height="4.865" />
      <rect x="252.56" y="492.723" fill="#C0C0C0" width="28.22" height="4.824" />
      <rect x="175.647" y="462.881" fill="#C0C0C0" width="118.754" height="4.865" />
      <rect x="175.647" y="471.803" fill="#C0C0C0" width="93.058" height="4.824" />
      <circle fill="#939393" cx="184.185" cy="443.268" r="7.768" />
      <rect x="175.264" y="456.266" fill="#505050" width="119.634" height="1.971" />

      <ellipse fill="none" stroke="#F3BC2A" strokeWidth="3" strokeLinejoin="round" stroke-miterlimit="10" cx="270.558" cy="486.288" rx="29.996" ry="10.116" />
    </g>
    <g>
      <g>
        <path d="M238.444,373.002h2.73v14.7h-2.73V373.002z" />
        <path
          d="M254.656,377.6c0.854,0.826,1.281,2.052,1.281,3.676v6.426h-2.625v-6.09c0-0.98-0.231-1.719-0.693-2.216
			c-0.462-0.497-1.121-0.745-1.974-0.745c-0.966,0-1.729,0.29-2.289,0.871c-0.56,0.581-0.84,1.417-0.84,2.51v5.67h-2.625v-11.214
			h2.499v1.448c0.434-0.518,0.979-0.909,1.638-1.176c0.658-0.266,1.4-0.398,2.226-0.398
			C252.668,376.362,253.802,376.775,254.656,377.6z"
        />
        <path
          d="M260.073,387.492c-0.868-0.238-1.561-0.539-2.079-0.903l1.008-1.995c0.504,0.336,1.109,0.605,1.816,0.809
			c0.707,0.203,1.403,0.305,2.089,0.305c1.568,0,2.352-0.413,2.352-1.239c0-0.392-0.2-0.665-0.599-0.819
			c-0.399-0.153-1.04-0.301-1.921-0.44c-0.924-0.14-1.677-0.301-2.257-0.483c-0.581-0.182-1.085-0.5-1.512-0.955
			c-0.427-0.455-0.641-1.089-0.641-1.9c0-1.064,0.444-1.914,1.333-2.552c0.889-0.637,2.09-0.955,3.602-0.955
			c0.77,0,1.54,0.087,2.31,0.262c0.77,0.176,1.4,0.41,1.89,0.704l-1.008,1.995c-0.952-0.561-2.023-0.841-3.213-0.841
			c-0.77,0-1.354,0.116-1.753,0.347c-0.399,0.231-0.599,0.536-0.599,0.914c0,0.42,0.213,0.718,0.641,0.893
			c0.427,0.175,1.088,0.339,1.984,0.493c0.896,0.14,1.631,0.301,2.205,0.483c0.574,0.182,1.067,0.49,1.48,0.924
			s0.62,1.05,0.62,1.848c0,1.05-0.455,1.89-1.365,2.521c-0.91,0.63-2.149,0.944-3.717,0.944
			C261.83,387.848,260.941,387.729,260.073,387.492z"
        />
        <path
          d="M280.948,376.488v11.214h-2.499v-1.429c-0.42,0.505-0.945,0.893-1.575,1.166s-1.309,0.409-2.037,0.409
			c-1.498,0-2.677-0.416-3.538-1.249c-0.861-0.833-1.292-2.068-1.292-3.707v-6.404h2.625v6.048c0,1.008,0.227,1.761,0.682,2.257
			c0.455,0.497,1.103,0.746,1.943,0.746c0.938,0,1.683-0.291,2.236-0.872c0.553-0.58,0.83-1.417,0.83-2.509v-5.67H280.948z"
        />
        <path
          d="M290.881,376.362v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.298-2.394,0.893
			c-0.574,0.595-0.861,1.452-0.861,2.572v5.439h-2.625v-11.214h2.499v1.638C287.647,376.95,288.977,376.362,290.881,376.362z"
        />
        <path
          d="M301.118,377.548c0.875,0.791,1.312,1.984,1.312,3.58v6.573h-2.478v-1.365c-0.322,0.49-0.78,0.864-1.375,1.123
			c-0.595,0.26-1.312,0.389-2.152,0.389s-1.575-0.144-2.205-0.431c-0.63-0.286-1.117-0.686-1.459-1.196
			c-0.343-0.511-0.515-1.089-0.515-1.732c0-1.009,0.375-1.816,1.124-2.426s1.929-0.913,3.539-0.913h2.898v-0.169
			c0-0.783-0.234-1.386-0.704-1.806c-0.469-0.42-1.165-0.63-2.089-0.63c-0.63,0-1.25,0.098-1.858,0.294s-1.124,0.47-1.543,0.819
			l-1.029-1.911c0.588-0.448,1.295-0.791,2.121-1.029c0.826-0.237,1.701-0.356,2.625-0.356
			C298.979,376.362,300.243,376.757,301.118,377.548z M298.724,385.486c0.511-0.301,0.872-0.731,1.082-1.291v-1.303h-2.709
			c-1.512,0-2.268,0.497-2.268,1.491c0,0.477,0.189,0.854,0.567,1.134c0.378,0.28,0.903,0.42,1.575,0.42
			C297.629,385.937,298.213,385.788,298.724,385.486z"
        />
        <path
          d="M315.555,377.6c0.854,0.826,1.281,2.052,1.281,3.676v6.426h-2.625v-6.09c0-0.98-0.231-1.719-0.693-2.216
			c-0.462-0.497-1.121-0.745-1.974-0.745c-0.966,0-1.729,0.29-2.289,0.871c-0.56,0.581-0.84,1.417-0.84,2.51v5.67h-2.625v-11.214
			h2.499v1.448c0.434-0.518,0.979-0.909,1.638-1.176c0.658-0.266,1.4-0.398,2.226-0.398
			C313.568,376.362,314.701,376.775,315.555,377.6z"
        />
        <path
          d="M322.296,387.114c-0.924-0.49-1.645-1.173-2.163-2.048c-0.518-0.875-0.777-1.865-0.777-2.972
			c0-1.105,0.259-2.093,0.777-2.961c0.518-0.868,1.235-1.547,2.152-2.037c0.917-0.489,1.963-0.734,3.14-0.734
			c1.105,0,2.075,0.224,2.908,0.672s1.459,1.092,1.879,1.932l-2.016,1.176c-0.322-0.518-0.725-0.906-1.207-1.165
			c-0.483-0.259-1.012-0.389-1.585-0.389c-0.98,0-1.792,0.318-2.436,0.955c-0.644,0.638-0.966,1.488-0.966,2.552
			c0,1.064,0.318,1.915,0.956,2.552s1.452,0.955,2.447,0.955c0.574,0,1.103-0.129,1.585-0.388c0.482-0.26,0.885-0.647,1.207-1.166
			l2.016,1.176c-0.434,0.84-1.067,1.488-1.9,1.942c-0.833,0.455-1.795,0.683-2.887,0.683
			C324.263,387.848,323.22,387.604,322.296,387.114z"
        />
        <path
          d="M342.813,382.934h-8.8c0.154,0.826,0.557,1.48,1.208,1.964s1.459,0.725,2.426,0.725c1.231,0,2.247-0.406,3.045-1.218
			l1.406,1.616c-0.504,0.603-1.141,1.058-1.91,1.365c-0.771,0.309-1.639,0.462-2.604,0.462c-1.232,0-2.317-0.244-3.255-0.734
			c-0.938-0.49-1.663-1.173-2.174-2.048s-0.767-1.865-0.767-2.972c0-1.092,0.249-2.075,0.746-2.95
			c0.496-0.875,1.187-1.558,2.068-2.048c0.882-0.489,1.876-0.734,2.982-0.734c1.092,0,2.068,0.241,2.929,0.724
			c0.861,0.483,1.533,1.163,2.017,2.037c0.482,0.875,0.725,1.887,0.725,3.035C342.855,382.339,342.841,382.598,342.813,382.934z
			 M335.053,379.207c-0.581,0.497-0.935,1.159-1.061,1.985h6.363c-0.112-0.812-0.455-1.471-1.029-1.975s-1.288-0.756-2.142-0.756
			C336.344,378.461,335.635,378.711,335.053,379.207z"
        />
        <path
          d="M240.208,410.114c-0.924-0.49-1.645-1.173-2.163-2.048c-0.518-0.875-0.777-1.865-0.777-2.972
			c0-1.105,0.259-2.093,0.777-2.961c0.518-0.867,1.235-1.547,2.152-2.037c0.917-0.489,1.963-0.734,3.14-0.734
			c1.105,0,2.075,0.224,2.908,0.672s1.459,1.092,1.879,1.932l-2.016,1.177c-0.322-0.519-0.725-0.906-1.208-1.166
			c-0.483-0.259-1.012-0.389-1.585-0.389c-0.98,0-1.792,0.319-2.436,0.956c-0.644,0.637-0.966,1.487-0.966,2.551
			c0,1.064,0.318,1.915,0.956,2.552c0.637,0.638,1.452,0.956,2.447,0.956c0.574,0,1.103-0.13,1.585-0.389s0.885-0.647,1.208-1.166
			l2.016,1.177c-0.434,0.84-1.067,1.487-1.9,1.942s-1.795,0.683-2.887,0.683C242.175,410.849,241.132,410.604,240.208,410.114z"
        />
        <path
          d="M258.467,400.548c0.875,0.791,1.312,1.984,1.312,3.58v6.573h-2.478v-1.365c-0.322,0.49-0.78,0.865-1.375,1.124
			s-1.312,0.389-2.152,0.389s-1.575-0.145-2.205-0.431c-0.63-0.287-1.117-0.687-1.459-1.197c-0.343-0.511-0.515-1.089-0.515-1.732
			c0-1.008,0.375-1.816,1.124-2.426c0.749-0.608,1.929-0.913,3.539-0.913h2.898v-0.168c0-0.784-0.234-1.387-0.704-1.807
			c-0.469-0.42-1.165-0.63-2.089-0.63c-0.63,0-1.25,0.099-1.858,0.294c-0.609,0.196-1.124,0.47-1.543,0.819l-1.029-1.911
			c0.588-0.448,1.295-0.791,2.121-1.029c0.826-0.237,1.701-0.356,2.625-0.356C256.328,399.362,257.592,399.757,258.467,400.548z
			 M256.073,408.486c0.511-0.301,0.872-0.731,1.082-1.291v-1.302h-2.709c-1.512,0-2.268,0.497-2.268,1.49
			c0,0.477,0.189,0.854,0.567,1.135c0.378,0.28,0.903,0.42,1.575,0.42C254.978,408.938,255.562,408.788,256.073,408.486z"
        />
        <path
          d="M269.629,399.362v2.499c-0.224-0.042-0.427-0.063-0.609-0.063c-1.022,0-1.82,0.298-2.394,0.893
			c-0.574,0.596-0.861,1.453-0.861,2.572v5.439h-2.625v-11.214h2.499v1.638C266.395,399.95,267.725,399.362,269.629,399.362z"
        />
        <path
          d="M282.733,395.12v15.582h-2.52v-1.449c-0.434,0.532-0.97,0.932-1.606,1.197c-0.637,0.266-1.341,0.399-2.111,0.399
			c-1.078,0-2.047-0.238-2.908-0.715c-0.861-0.476-1.537-1.151-2.026-2.026c-0.49-0.875-0.735-1.879-0.735-3.014
			c0-1.134,0.245-2.135,0.735-3.003c0.49-0.867,1.166-1.539,2.026-2.016c0.861-0.476,1.83-0.714,2.908-0.714
			c0.742,0,1.421,0.126,2.037,0.378s1.141,0.63,1.575,1.134v-5.754H282.733z M278.511,408.171c0.504-0.287,0.903-0.696,1.197-1.229
			s0.441-1.148,0.441-1.849c0-0.699-0.147-1.315-0.441-1.848s-0.693-0.941-1.197-1.229s-1.071-0.431-1.701-0.431
			c-0.63,0-1.197,0.144-1.701,0.431s-0.903,0.696-1.197,1.229c-0.294,0.532-0.441,1.148-0.441,1.848c0,0.7,0.147,1.316,0.441,1.849
			c0.294,0.532,0.693,0.941,1.197,1.229s1.071,0.431,1.701,0.431C277.441,408.602,278.008,408.459,278.511,408.171z"
        />
      </g>
    </g>
  </svg>
)

export default VinLocation
